(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-about-mario"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-obt-am]');
    if (!sections.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (root) {
      var items = root.querySelectorAll('[data-am-rise]');
      if (!items.length) return;

      if (reduce || !('IntersectionObserver' in window)) return; // stays visible + static

      root.classList.add('is-armed');

      var reveal = function (el, i) {
        el.style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
        el.classList.add('is-in');
      };

      // failsafe: never leave content hidden
      var failsafe = window.setTimeout(function () {
        items.forEach(function (el) { el.classList.add('is-in'); });
      }, 2600);

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target, parseInt(entry.target.getAttribute('data-i') || '0', 10));
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

      items.forEach(function (el, i) {
        el.setAttribute('data-i', i % 5);
        io.observe(el);
      });

      // clear failsafe once the last item is in (best effort)
      root.addEventListener('transitionend', function () {
        var pending = root.querySelectorAll('[data-am-rise]:not(.is-in)');
        if (!pending.length) window.clearTimeout(failsafe);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-about-split"] && !Shopify.designMode) return;
  try {
    
  /* obt-reveal — vanilla custom element. Adds .is-in to the host section when
     it scrolls into view, which triggers the CSS reveal animation once.
     IntersectionObserver-gated, reduced-motion aware, no layout animation,
     no library, NO Liquid. If reveal is off or the host already has the
     animation flag, falls back to instantly visible (CSS handles that). */
  if (!customElements.get('obt-reveal')) {
    class ObtReveal extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.obt-about-split');
        if (!section) return;
        this.section = section;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Reveal off, reduced-motion, or no IO → leave content visible. Do NOT
        // arm: never add .obt-armed here, so no opacity:0 ever applies.
        if (this.dataset.reveal === 'off' || reduce || !('IntersectionObserver' in window)) {
          this.showAll();
          return;
        }

        // Animated path: arm the section (now the hidden initial state applies),
        // then reveal on scroll. A safety timeout guarantees we never stay blank
        // if the observer never fires (theme editor / odd storefront loads).
        section.classList.add('obt-armed');

        this.io = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.showAll();
              break;
            }
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
        this.io.observe(section);

        this.safety = window.setTimeout(() => this.showAll(), 1600);
      }

      showAll() {
        if (this.io) { this.io.disconnect(); this.io = null; }
        if (this.safety) { window.clearTimeout(this.safety); this.safety = null; }
        if (this.section) this.section.classList.add('is-in');
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.safety) window.clearTimeout(this.safety);
      }
    }
    customElements.define('obt-reveal', ObtReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-admission"] && !Shopify.designMode) return;
  try {
    
  /* obt-admission-media — vanilla custom element.
     Fail-safe reveal: the CSS hidden state applies ONLY when the section
     carries .obt-armed. This element arms the section on the animated path,
     then releases the reveal (via [data-obt-inview]) the first time the media
     enters the viewport. If the IntersectionObserver never fires (theme
     editor, odd loads), a safety timeout force-reveals everything. Without JS
     the section is never armed, so content is fully visible by default.
     Pure IntersectionObserver, no layout reads, reduced-motion aware. NO Liquid. */
  if (!customElements.get('obt-admission-media')) {
    class ObtAdmissionMedia extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.obt-admission');
        if (!this.section) return;

        // No animation requested → leave content visible, never arm.
        if (!this.section.hasAttribute('data-obt-animate')) {
          return;
        }

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Reduced motion → leave content visible, never arm.
        if (reduce) {
          return;
        }

        // Arm: from here on the CSS hidden initial state takes effect.
        this.section.classList.add('obt-armed');

        // Not scroll-gated → reveal immediately (CSS animation plays at once).
        if (this.dataset.onScroll !== 'true' || !this.section.hasAttribute('data-obt-on-scroll')) {
          this.section.setAttribute('data-obt-inview', '');
          return;
        }

        // No IntersectionObserver support → reveal immediately.
        if (!('IntersectionObserver' in window)) {
          this.section.setAttribute('data-obt-inview', '');
          return;
        }

        this.io = new IntersectionObserver((entries) => {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this._reveal();
              break;
            }
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
        this.io.observe(this.section);

        // Safety net: if the observer never fires, force the reveal.
        this.safetyTimer = window.setTimeout(this._reveal.bind(this), 1600);
      }

      _reveal() {
        if (this.section) { this.section.setAttribute('data-obt-inview', ''); }
        if (this.io) { this.io.disconnect(); this.io = null; }
        if (this.safetyTimer) { window.clearTimeout(this.safetyTimer); this.safetyTimer = null; }
      }

      disconnectedCallback() {
        if (this.io) { this.io.disconnect(); this.io = null; }
        if (this.safetyTimer) { window.clearTimeout(this.safetyTimer); this.safetyTimer = null; }
      }
    }
    customElements.define('obt-admission-media', ObtAdmissionMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-apply-book"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── smooth-scroll: any CTA to #obt-book scrolls the real scroller here ── */
    /* obt-motion.js owns the single source of truth for "what is actually
       scrolling" (on Horizon desktop the window does not scroll). Fall back
       to the local probe only if the runtime is not on the page. */
    function detectScroller() {
      if (typeof window.obtScroller === 'function') {
        var s = window.obtScroller();
        return s === document.scrollingElement ? window : s;
      }
      var pw = document.querySelector('.page-wrapper');
      if (pw) { var ov = getComputedStyle(pw).overflowY; if (ov === 'auto' || ov === 'scroll') return pw; }
      return window;
    }
    function scrollToBook(e) {
      var a = e.target.closest && e.target.closest('a[href="#obt-book"], [data-obt-scrollto]');
      if (!a) return;
      var href = a.getAttribute('href') || a.getAttribute('data-obt-scrollto') || '#obt-book';
      if (href.indexOf('#obt-book') === -1) return;
      var target = document.getElementById('obt-book');
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var scroller = detectScroller();
      var offset = 90;
      if (scroller === window) {
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        var top2 = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - offset;
        scroller.scrollTo({ top: top2, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (history && history.replaceState) { try { history.replaceState(null, '', '#obt-book'); } catch (err) {} }
    }
    if (!document.documentElement.dataset.obtBookScroll) {
      document.documentElement.dataset.obtBookScroll = '1';
      document.addEventListener('click', scrollToBook);
    }

    /* Entrance reveals are the global .obt-reveal grammar (obt-motion.css +
       obt-motion.js), which already carries the per-element failsafe and the
       scrolled-past sweep this section used to duplicate. */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-apply-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (!root || root.dataset.afInit === '1') return;
      root.dataset.afInit = '1';
      var items = root.querySelectorAll('[data-af-item]');

      /* collapse all (JS-driven) except any pre-opened first item */
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-af-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var t = other.querySelector('[data-af-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          item.classList.toggle('is-open', !isOpen);
          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });

      /* Entrance reveals are the global .obt-reveal grammar (obt-motion.js). */
    }
    function boot() { document.querySelectorAll('[data-obt-apfaq]').forEach(initFaq); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { if (e.target) e.target.querySelectorAll('[data-obt-apfaq]').forEach(initFaq); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-apply-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.dataset.apInit === '1') return;
      root.dataset.apInit = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* count-up metrics. Entrance reveals are the global .obt-reveal grammar
         (obt-motion.js); the magnetic CTA is the global one in obt-fx.js. */
      var counters = root.querySelectorAll('[data-ap-count]');

      function parseNum(s) { var m = String(s).match(/[\d.,]+/); return m ? parseFloat(m[0].replace(/,/g, '')) : null; }
      function runCount(el) {
        var finalStr = el.getAttribute('data-ap-final') || el.textContent;
        var target = parseNum(finalStr);
        if (target === null) return;
        var prefix = finalStr.slice(0, finalStr.search(/[\d.,]/));
        var mtail = finalStr.match(/[\d.,]+(.*)$/);
        var suffix = mtail ? mtail[1] : '';
        var dur = 1300, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = prefix + val.toLocaleString('bg-BG') + suffix;
          if (p < 1) requestAnimationFrame(step); else el.textContent = finalStr;
        }
        requestAnimationFrame(step);
      }

      if (reduce || !('IntersectionObserver' in window)) return;

      if (counters.length) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { runCount(en.target); cio.unobserve(en.target); } });
        }, { threshold: 0.6 });
        counters.forEach(function (el) { cio.observe(el); });
      }
    }

    function boot() { document.querySelectorAll('[data-obt-aphero]').forEach(initHero); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-obt-aphero]').forEach(initHero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-apply-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWall(root) {
      if (!root || root.dataset.awInit === '1') return;
      root.dataset.awInit = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ── lightbox ── */
      var modal = root.querySelector('[data-aw-modal]');
      var modalOpen = false, lastFocused = null;
      function openModal(tile) {
        if (!modal) return;
        lastFocused = tile;
        var name = tile.getAttribute('data-name') || '';
        var setTxt = function (sel, val) { var el = modal.querySelector(sel); if (el) el.textContent = val; };
        setTxt('[data-aw-modalname]', name);
        setTxt('[data-aw-modalrole]', tile.getAttribute('data-role') || '');
        setTxt('[data-aw-modalquote]', tile.getAttribute('data-quote') || '');
        var img = modal.querySelector('[data-aw-modalimg]');
        var src = tile.getAttribute('data-img');
        var tileImg = tile.querySelector('img');
        if (img) {
          if (src) {
            img.src = src;
            /* carry the tile's alt across so the lightbox image is not a
               silent, unlabelled graphic for a screen reader */
            img.alt = (tileImg && tileImg.getAttribute('alt')) || name;
            img.hidden = false;
          } else { img.removeAttribute('src'); img.alt = ''; img.hidden = true; }
        }
        var av = modal.querySelector('[data-aw-modalav]');
        if (av) av.textContent = (name.trim().charAt(0) || '•');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        modalOpen = true;
        document.body.style.overflow = 'hidden';
        var cb = modal.querySelector('[data-aw-close]');
        if (cb && cb.focus) cb.focus();
      }
      function closeModal() {
        if (!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modalOpen = false;
        document.body.style.overflow = '';
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }
      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-aw-open]');
        if (t && root.contains(t)) { openModal(t); return; }
        if (e.target.closest('[data-aw-close]')) closeModal();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modalOpen) closeModal(); });

      /* ── count-up stats ── */
      var counters = root.querySelectorAll('[data-aw-count]');
      function parseNum(s) { var m = String(s).match(/[\d.,]+/); return m ? parseFloat(m[0].replace(/,/g, '')) : null; }
      function runCount(el) {
        var finalStr = el.getAttribute('data-aw-final') || el.textContent;
        var target = parseNum(finalStr);
        if (target === null) return;
        var prefix = finalStr.slice(0, finalStr.search(/[\d.,]/));
        var mtail = finalStr.match(/[\d.,]+(.*)$/);
        var suffix = mtail ? mtail[1] : '';
        var dur = 1300, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var val = Math.round(target * (1 - Math.pow(1 - p, 3)));
          el.textContent = prefix + val.toLocaleString('bg-BG') + suffix;
          if (p < 1) requestAnimationFrame(step); else el.textContent = finalStr;
        }
        requestAnimationFrame(step);
      }

      /* Entrance reveals are the global .obt-reveal grammar (obt-motion.js). */
      if (reduce || !('IntersectionObserver' in window)) return;
      if (counters.length) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { runCount(en.target); cio.unobserve(en.target); } });
        }, { threshold: 0.6 });
        counters.forEach(function (el) { cio.observe(el); });
      }
    }
    function boot() { document.querySelectorAll('[data-obt-apwall]').forEach(initWall); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { if (e.target) e.target.querySelectorAll('[data-obt-apwall]').forEach(initWall); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-arc-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('obt-reveal')) {
    class ObtReveal extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { this.classList.add('is-revealed'); return; }
        this.io = new IntersectionObserver((es, o) => {
          es.forEach((e) => { if (e.isIntersecting) { this.classList.add('is-revealed'); o.disconnect(); } });
        }, { threshold: 0.15 });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    }
    customElements.define('obt-reveal', ObtReveal);
  }

  if (!customElements.get('obt-arc-text')) {
    class ObtArcText extends HTMLElement {
      connectedCallback() {
        this.lines = Array.from(this.querySelectorAll('[data-line]'));
        this.reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.stepDeg = parseFloat(this.getAttribute('data-step')) || 20;
        this.radiusVh = parseFloat(this.getAttribute('data-radius')) || 40;
        this.target = 0; this.current = 0; this.rendered = -1; this.rafId = null; this.active = true;
        this.onFrame = this.onFrame.bind(this);
        this.onScroll = () => this.start();
        if (this.reduceQuery.matches) { this.style.setProperty('--arc-p', '1'); return; }
        this.target = this.current = this.progress();
        this.apply(true);
        this.start();
        window.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.observer = new IntersectionObserver(
          (entries) => entries.forEach((e) => { this.active = e.isIntersecting; if (this.active) this.start(); }),
          { rootMargin: '300px 0px' }
        );
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.rafId) cancelAnimationFrame(this.rafId);
        window.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
      }
      start() { if (this.rafId || this.reduceQuery.matches) return; this.rafId = requestAnimationFrame(this.onFrame); }
      onFrame() {
        this.target = this.progress();
        this.current += (this.target - this.current) * 0.14;
        if (Math.abs(this.target - this.current) < 0.0006) this.current = this.target;
        this.apply(false);
        const settled = Math.abs(this.target - this.current) < 0.0006;
        if (this.active || !settled) this.rafId = requestAnimationFrame(this.onFrame); else this.rafId = null;
      }
      progress() {
        const rect = this.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height - vh;
        if (total <= 0) return 0;
        return Math.min(1, Math.max(0, -rect.top / total));
      }
      apply(force) {
        const p = this.current;
        if (!force && Math.abs(p - this.rendered) < 0.0004) return;
        this.rendered = p;
        const n = this.lines.length;
        if (!n) return;
        const active = p * (n - 1);
        const radius = Math.min(window.innerHeight * (this.radiusVh / 100), 360);
        for (let i = 0; i < n; i++) {
          const off = i - active;
          const ang = off * this.stepDeg;
          const rad = (ang * Math.PI) / 180;
          const y = Math.sin(rad) * radius;
          const z = (Math.cos(rad) - 1) * radius;
          const opacity = Math.max(0, 1 - Math.abs(off) / 3);
          const line = this.lines[i];
          line.style.transform = 'translate(-50%, -50%) translateY(' + y.toFixed(1) + 'px) translateZ(' + z.toFixed(1) + 'px) rotateX(' + ang.toFixed(2) + 'deg)';
          line.style.opacity = opacity.toFixed(3);
          line.style.zIndex = String(1000 - Math.round(Math.abs(off) * 10));
        }
      }
    }
    customElements.define('obt-arc-text', ObtArcText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-bull-hero"] && !Shopify.designMode) return;
  try {
    
/* ONEBAR Monument hero v7 — entrance and everything ambient are PURE CSS.
   JS does exactly two things now: the metric count-up, and coordinating the
   entrance replay with the gate.

   ⚠️ GSAP IS GONE, AND SO IS THE LAST THIRD-PARTY SCRIPT ON THE HOMEPAGE.
   This section used to inject gsap.min.js from cdnjs.cloudflare.com on the
   first pointermove, purely to run a quickTo parallax that drifted the
   ambient glow and the sculpt by up to 16px. That is ~70KB and a fourth
   origin (DNS, TLS, connect) bought on the visitor's first mouse movement,
   for an effect most visitors never consciously saw — and one that belonged
   to the same family Mr. Markov asked to remove on 2026-08-13: decoration
   that chases the cursor. Nothing else in the theme calls window.obtLoadGsap;
   it was checked before deleting. Do not reintroduce it without a dependency
   that CSS genuinely cannot express. */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var raw = el.textContent;
    var m = String(raw).match(/^(\D*)(\d[\d.,\s]*)(.*)$/);
    if (!m) return;
    var digits = m[2].replace(/[\s,]/g, '');
    var dec = (digits.split('.')[1] || '').length;
    var num = parseFloat(digits);
    if (!isFinite(num) || num <= 0) return;
    var pre = m[1], post = m[3], t0 = 0, dur = 1300;
    function frame(ts) {
      if (!t0) t0 = ts;
      var q = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - q, 3);
      var v = (num * e).toFixed(dec);
      el.textContent = pre + Number(v).toLocaleString('bg-BG') + post;
      if (q < 1) requestAnimationFrame(frame); else el.textContent = raw;
    }
    requestAnimationFrame(frame);
  }

  function initHero(root) {
    if (root.getAttribute('data-mon-init')) return;
    root.setAttribute('data-mon-init', '1');
    root.classList.add('is-js');

    /* pause the marquee once the hero has scrolled away. It is the only loop
       left in this section; the ken burns and the two axis ticks were deleted
       outright on 2026-08-13. Decoration only, never gates readable content. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        root.classList.toggle('is-off', !es[0].isIntersecting);
      }, { threshold: 0 }).observe(root);
    }

    var stats = root.querySelector('[data-hh-stats]');
    var counts = stats ? Array.prototype.slice.call(stats.querySelectorAll('[data-hh-count]')) : [];
    var statsFired = false;
    function revealStats() {
      if (statsFired || !stats) return; statsFired = true;
      stats.classList.add('is-in');
      if (!REDUCE) counts.forEach(countUp);
    }
    function armStats() {
      if (!stats) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { revealStats(); io.disconnect(); } });
        }, { threshold: 0.25 });
        io.observe(stats);
      } else { revealStats(); }
      window.setTimeout(revealStats, 3500);
    }

    function replayEntrance() {
      root.classList.add('is-wait');
      window.setTimeout(function () {
        root.classList.remove('is-wait');
        void root.offsetWidth;
        if (root.getAnimations) {
          root.getAnimations({ subtree: true }).forEach(function (a) {
            try { if (a.animationName) a.currentTime = 0; } catch (e) {}
          });
        }
      }, 540);
    }

    var gate = document.querySelector('.obt-gate');
    if (!gate || REDUCE) {
      armStats();
    } else {
      var wasOpen = gate.classList.contains('is-open');
      var replayed = false;
      function holdReplay() {
        if (replayed) return; replayed = true;
        replayEntrance(); armStats();
      }
      var mo = new MutationObserver(function () {
        if (!gate.isConnected) { mo.disconnect(); po.disconnect(); if (wasOpen) holdReplay(); else armStats(); return; }
        if (gate.classList.contains('is-open')) wasOpen = true;
        if (wasOpen && gate.classList.contains('is-exit')) holdReplay();
      });
      mo.observe(gate, { attributes: true, attributeFilter: ['class'] });
      var po = new MutationObserver(function () {
        if (!gate.isConnected) { mo.disconnect(); po.disconnect(); if (wasOpen && !replayed) holdReplay(); else if (!wasOpen) armStats(); }
      });
      po.observe(gate.parentNode || document.body, { childList: true });
      window.setTimeout(function () { if (!replayed) armStats(); }, 4500);
    }
  }

  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-obt-mon]'), initHero); }
  if (document.readyState === 'complete' || document.readyState === 'interactive') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-category-banner"] && !Shopify.designMode) return;
  try {
    
  /* obt-category-banner — vanilla custom element.
     Adds .is-revealed to the host section when the banner scrolls into view,
     triggering the CSS reveal animation. IntersectionObserver, one-shot,
     reduced-motion aware, no Liquid, no libraries. Static (revealed) when
     IO is unavailable or motion is disabled so content is never hidden. */
  if (!customElements.get('obt-category-banner')) {
    class ObtCategoryBanner extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.obt-category-banner');
        if (!this.section) return;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const noReveal = this.dataset.reveal === 'off';

        // Reduced-motion or reveal disabled: leave content visible, never arm.
        if (reduce || noReveal || !('IntersectionObserver' in window)) {
          this.section.classList.add('is-revealed');
          return;
        }

        // Animated path only: arm the hidden state, then reveal as a
        // progressive enhancement. If anything below fails, the safety
        // timeout still force-reveals everything.
        this.section.classList.add('obt-armed');

        this.io = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.section.classList.add('is-revealed');
              this.io.disconnect();
              this.io = null;
              if (this.safety) {
                clearTimeout(this.safety);
                this.safety = null;
              }
              break;
            }
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

        this.io.observe(this.section);

        // Fail-safe: if the observer never fires (theme editor, odd loads),
        // force-reveal so content can never stay blank.
        this.safety = setTimeout(() => {
          this.section.classList.add('is-revealed');
          if (this.io) {
            this.io.disconnect();
            this.io = null;
          }
          this.safety = null;
        }, 1600);
      }

      disconnectedCallback() {
        if (this.io) {
          this.io.disconnect();
          this.io = null;
        }
        if (this.safety) {
          clearTimeout(this.safety);
          this.safety = null;
        }
      }
    }
    customElements.define('obt-category-banner', ObtCategoryBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-chess-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('obt-chess-hero')) {
    class ObtChessHero extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.obt-chess-hero__video');
        this.reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.animationsActive = this.getAttribute('data-enable-scroll') !== 'false';
        this.scrub = this.animationsActive;
        this.srcDesktop = this.getAttribute('data-video-desktop') || '';
        this.srcMobile = this.getAttribute('data-video-mobile') || '';

        this.target = 0;
        this.current = 0;
        this.rendered = -1;
        this.rafId = null;
        this.active = false;
        this.phase = '';
        this.seeking = false;
        this.pendingTime = null;

        this.onFrame = this.onFrame.bind(this);
        this.applySource = this.applySource.bind(this);
        this.scrollToNext = this.scrollToNext.bind(this);

        if (this.video) {
          this.video.muted = true;
          this.video.pause();
          this.video.addEventListener('seeked', () => {
            this.seeking = false;
            if (this.pendingTime != null) {
              const t = this.pendingTime;
              this.pendingTime = null;
              this.seek(t);
            }
          });
          this.video.addEventListener('loadedmetadata', () => {
            if (this.scrub && this.video.duration) {
              try { this.video.currentTime = this.current * this.video.duration; } catch (e) {}
            }
            this.apply(true);
          });
        }

        this.applySource();
        if (this.mobileQuery.addEventListener) this.mobileQuery.addEventListener('change', this.applySource);

        this.querySelectorAll('[data-scroll-next]').forEach((btn) => btn.addEventListener('click', this.scrollToNext));

        this.target = this.current = this.computeProgress();
        this.apply(true);

        // Start immediately (assume visible). The observer only pauses when off-screen.
        this.active = true;
        if (this.animationsActive) this.start();

        // Belt-and-suspenders: any scroll (incl. .page-wrapper on desktop) re-arms the loop.
        this.onScroll = () => { if (this.animationsActive) this.start(); };
        window.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              this.active = entry.isIntersecting;
              if (this.active && this.animationsActive) this.start();
            }
          },
          { rootMargin: '300px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.rafId) cancelAnimationFrame(this.rafId);
        if (this.mobileQuery && this.mobileQuery.removeEventListener) this.mobileQuery.removeEventListener('change', this.applySource);
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll, { capture: true });
          window.removeEventListener('resize', this.onScroll);
        }
      }

      applySource() {
        if (!this.video) return;
        const want = this.mobileQuery.matches && this.srcMobile ? this.srcMobile : this.srcDesktop;
        if (!want) return;
        const source = this.video.querySelector('source');
        if (source && source.getAttribute('src') === want && this.video.currentSrc) return;
        if (source) source.setAttribute('src', want);
        else this.video.setAttribute('src', want);
        this.video.load();
      }

      start() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(this.onFrame);
      }

      onFrame() {
        // Watchdog: if a seek never reported back, clear the lock so scrubbing can't freeze.
        if (this.seeking && performance.now() - (this.seekStart || 0) > 250) this.seeking = false;
        this.target = this.reduceQuery.matches ? 0 : this.computeProgress();
        this.current += (this.target - this.current) * 0.12;
        if (Math.abs(this.target - this.current) < 0.0006) this.current = this.target;
        this.apply(false);

        const settled = Math.abs(this.target - this.current) < 0.0006;
        if (this.active || !settled) this.rafId = requestAnimationFrame(this.onFrame);
        else this.rafId = null;
      }

      computeProgress() {
        const rect = this.getBoundingClientRect();
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height - viewport;
        if (total <= 0) return 0;
        return Math.min(1, Math.max(0, -rect.top / total));
      }

      seek(t) {
        if (!this.video || !this.video.duration) return;
        if (this.seeking) { this.pendingTime = t; return; }
        if (Math.abs(t - this.video.currentTime) < 0.02) return;
        this.seeking = true;
        this.seekStart = performance.now();
        try { this.video.currentTime = t; } catch (e) { this.seeking = false; }
      }

      apply(force) {
        const p = this.current;
        if (!force && Math.abs(p - this.rendered) < 0.0004) return;
        this.rendered = p;

        this.style.setProperty('--obt-p', p.toFixed(4));

        const phase = p > 0.6 ? 'outro' : p > 0.35 ? 'mid' : 'intro';
        if (phase !== this.phase) {
          this.phase = phase;
          this.setAttribute('data-phase', phase);
        }

        if (this.scrub && !this.reduceQuery.matches && this.video && this.video.duration) {
          this.seek(p * this.video.duration);
        }
      }

      getScrollContainer() {
        if (window.matchMedia('(min-width: 990px)').matches) {
          return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
        }
        return document.scrollingElement || document.documentElement;
      }

      scrollToNext(event) {
        if (event) event.preventDefault();
        const wrapper = this.closest('.shopify-section') || this.parentElement;
        const next = wrapper && wrapper.nextElementSibling;
        if (next && next.scrollIntoView) {
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        const container = this.getScrollContainer();
        container.scrollTo({ top: container.scrollTop + (window.innerHeight || 800), behavior: 'smooth' });
      }
    }

    customElements.define('obt-chess-hero', ObtChessHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-community-mechanics"] && !Shopify.designMode) return;
  try {
    
  /* obt-mechanic-grid + obt-leaderboard — vanilla custom elements.
     - The section root toggles [data-obt-inview] when scrolled into view so the
       CSS reveal/stagger fires (and only once), honoring data-obt-scroll.
     - obt-leaderboard additionally counts each rank score up from 0 to its
       target on first reveal (the streak "🔥" tally), reduced-motion aware.
     GPU-only, IntersectionObserver-driven, NO Liquid, no libraries. */

  if (!customElements.get('obt-mechanic-grid')) {
    class ObtMechanicGrid extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.obt-community-mechanics');
        this._section = section;
        if (!section || !section.hasAttribute('data-obt-animate')) return;
        if (section.dataset.obtScroll !== 'true') {
          section.setAttribute('data-obt-inview', '');
          return;
        }
        if (!('IntersectionObserver' in window)) {
          section.setAttribute('data-obt-inview', '');
          return;
        }
        // Arm: only now does the CSS pre-state (opacity:0) apply. If anything
        // below is interrupted, the safety timeout still reveals the content.
        section.classList.add('obt-armed');
        this._io = new IntersectionObserver((entries, obs) => {
          if (entries[0].isIntersecting) {
            section.setAttribute('data-obt-inview', '');
            obs.disconnect();
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
        this._io.observe(section);
        // Safety: if the observer never fires (theme editor, odd loads), force
        // the reveal so the section can never stay blank.
        this._safety = setTimeout(() => section.setAttribute('data-obt-inview', ''), 1600);
      }
      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        if (this._safety) clearTimeout(this._safety);
      }
    }
    customElements.define('obt-mechanic-grid', ObtMechanicGrid);
  }

  if (!customElements.get('obt-leaderboard')) {
    class ObtLeaderboard extends HTMLElement {
      connectedCallback() {
        this.counted = false;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scores = Array.from(this.querySelectorAll('[data-obt-count]'));

        if (reduce || !('IntersectionObserver' in window) || !this.scores.length) {
          return; // static final values already in markup
        }

        this._io = new IntersectionObserver((entries, obs) => {
          if (entries[0].isIntersecting && !this.counted) {
            this.counted = true;
            this._runCounts();
            obs.disconnect();
          }
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.3 });
        this._io.observe(this);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }

      _runCounts() {
        const dur = 900;
        for (const el of this.scores) {
          const target = parseFloat(el.dataset.obtCount);
          if (isNaN(target)) continue;
          const suffix = el.dataset.obtSuffix || '';
          const start = performance.now();
          const step = (now) => {
            const t = Math.min((now - start) / dur, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (t < 1) requestAnimationFrame(step);
            else el.textContent = target + suffix;
          };
          requestAnimationFrame(step);
        }
      }
    }
    customElements.define('obt-leaderboard', ObtLeaderboard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-cta-ticket"] && !Shopify.designMode) return;
  try {
    
  /* ── obt-flicker — canvas that shimmers the wordmark out of pixel noise.
     Port of source initGrid: render the word to an offscreen canvas, mark
     letter cells where alpha > 90, then per-frame re-roll 14% of in-letter
     cells / 7% of outside cells, drawing 5px squares on an 11px pitch in
     accent (inside) / faint sand (outside). Rebuilds on font load + resize.
     IntersectionObserver pauses off-screen. Reduced-motion = static word. */
  if (!customElements.get('obt-flicker')) {
    class ObtFlicker extends HTMLElement {
      connectedCallback() {
        this.cv = this.querySelector('canvas');
        if (!this.cv) return;
        this.word = (this.dataset.word || 'ONEBAR').toString();
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.staticMode = this.dataset.static === 'on' || this.reduce;

        this.ctx = this.cv.getContext('2d');
        this.cell = 11;
        this.sq = 5;
        this.dpr = Math.min(2, window.devicePixelRatio || 1);
        this.cols = 0; this.rows = 0;
        this.cells = null; this.mask = null;
        this.lastW = 0; this.lastH = 0;
        this.inView = true;
        this.raf = 0;

        this._build = this._build.bind(this);
        this._draw = this._draw.bind(this);

        this._build();

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => { this.lastW = 0; this._build(); });
        }

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((es) => {
            this.inView = es[0].isIntersecting;
            if (this.inView && !this.staticMode && !this.raf) {
              this.raf = requestAnimationFrame(this._draw);
            }
          }, { threshold: 0 });
          this.io.observe(this);
        }

        this._onResize = () => {
          clearTimeout(this._rt);
          this._rt = setTimeout(() => { this.lastW = 0; this._build(); }, 200);
        };
        window.addEventListener('resize', this._onResize);

        if (this.staticMode) {
          // draw once: full-strength letter mask, no animation
          this._draw(true);
        } else {
          this.raf = requestAnimationFrame(this._draw);
        }
      }

      disconnectedCallback() {
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.io) this.io.disconnect();
        window.removeEventListener('resize', this._onResize);
        clearTimeout(this._rt);
      }

      _build() {
        const host = this.cv.parentElement;
        if (!host) return;
        const W = host.clientWidth, H = host.clientHeight;
        if (!W || !H || (W === this.lastW && H === this.lastH)) return;
        this.lastW = W; this.lastH = H;
        this.cv.width = W * this.dpr;
        this.cv.height = H * this.dpr;
        this.cols = Math.floor(W / this.cell);
        this.rows = Math.floor(H / this.cell);
        if (this.cols < 1 || this.rows < 1) return;

        const off = document.createElement('canvas');
        off.width = this.cols; off.height = this.rows;
        const o = off.getContext('2d');
        o.clearRect(0, 0, this.cols, this.rows);
        o.fillStyle = '#fff';
        o.textAlign = 'center';
        o.textBaseline = 'middle';
        let fs = this.rows * 0.82;
        o.font = '900 italic ' + fs + 'px Archivo, Arial, sans-serif';
        const tw = o.measureText(this.word).width || 1;
        fs = fs * (this.cols * 0.84) / tw;
        o.font = '900 italic ' + fs + 'px Archivo, Arial, sans-serif';
        o.fillText(this.word, this.cols / 2, this.rows * 0.3);

        const data = o.getImageData(0, 0, this.cols, this.rows).data;
        this.mask = new Uint8Array(this.cols * this.rows);
        for (let i = 0; i < this.cols * this.rows; i++) {
          this.mask[i] = data[i * 4 + 3] > 90 ? 1 : 0;
        }
        this.cells = new Float32Array(this.cols * this.rows);
        for (let i = 0; i < this.cells.length; i++) this.cells[i] = Math.random();

        if (this.staticMode) this._draw(true);
      }

      _readAccent() {
        // resolve the inline --obt-accent (and sand) from the section root
        const root = this.closest('.obt-cta-ticket') || this;
        const cs = getComputedStyle(root);
        this.accent = (cs.getPropertyValue('--obt-accent') || '#FF5A1E').trim();
        this.sand = (cs.getPropertyValue('--obt-sand') || '#E8C690').trim();
      }

      _draw(once) {
        if (!once && !this.staticMode) this.raf = requestAnimationFrame(this._draw);
        if (!this.cells || !this.ctx) return;
        if (!once && (!this.inView)) { this.raf = 0; return; }
        if (!this.accent) this._readAccent();

        const ctx = this.ctx, cols = this.cols, rows = this.rows;
        const cell = this.cell, sq = this.sq, dpr = this.dpr;
        ctx.clearRect(0, 0, this.cv.width, this.cv.height);

        for (let y = 0; y < rows; y++) {
          for (let x = 0; x < cols; x++) {
            const idx = y * cols + x;
            const inText = this.mask[idx];
            if (!once && Math.random() < (inText ? 0.14 : 0.07)) this.cells[idx] = Math.random();
            const seed = once ? (inText ? 1 : 0.5) : this.cells[idx];
            const op = seed * (inText ? 0.55 : 0.05);
            if (op < 0.02) continue;
            ctx.fillStyle = inText ? this._rgba(this.accent, op) : this._rgba(this.sand, op);
            ctx.fillRect(x * cell * dpr, y * cell * dpr, sq * dpr, sq * dpr);
          }
        }
      }

      _rgba(color, op) {
        // accept #rrggbb / #rgb; fall back to the source's literals otherwise
        let c = color;
        if (c.charAt(0) === '#') {
          if (c.length === 4) c = '#' + c[1] + c[1] + c[2] + c[2] + c[3] + c[3];
          const r = parseInt(c.slice(1, 3), 16);
          const g = parseInt(c.slice(3, 5), 16);
          const b = parseInt(c.slice(5, 7), 16);
          if (!isNaN(r) && !isNaN(g) && !isNaN(b)) return 'rgba(' + r + ',' + g + ',' + b + ',' + op + ')';
        }
        return color;
      }
    }
    customElements.define('obt-flicker', ObtFlicker);
  }

  /* ── Lazy, idempotent GSAP loader (shared across the whole page). ──
     Loads gsap core once, then any requested plugins once, registers them,
     and resolves with window.gsap. Never blocks LCP — only called when a
     section is in view AND reduced-motion is not requested. */
  window.obtLoadGsap = window.obtLoadGsap || function(plugins){
    window.__obtGsapP = window.__obtGsapP || new Promise(function(res){
      var core = document.createElement("script");
      core.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js";
      core.onload = function(){ res(); };
      document.head.appendChild(core);
    });
    return window.__obtGsapP.then(function(){
      var jobs = (plugins||[]).map(function(p){
        if (window[p]) return Promise.resolve();
        window["__obtP_"+p] = window["__obtP_"+p] || new Promise(function(r){
          var s=document.createElement("script");
          s.src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/"+p+".min.js";
          s.onload=function(){ r(); }; document.head.appendChild(s);
        });
        return window["__obtP_"+p];
      });
      return Promise.all(jobs).then(function(){
        if (plugins) plugins.forEach(function(p){ if (window.gsap && window[p]) window.gsap.registerPlugin(window[p]); });
        return window.gsap;
      });
    });
  };

  /* ── obt-ticket — drag-to-rotate boarding-pass (GSAP hybrid).
     Front + back in preserve-3d. _apply() composes rotateY(rotY) + resting
     rotateX(6deg) / hover lift, and toggles face opacity by rotY mod 360 in
     (90,270). Hover peels the tear-off stub (CSS + JS stub). GSAP Draggable
     (type:"rotation") on an invisible proxy captures the spin; each tick maps
     the proxy rotation onto rotY and re-applies. On release Draggable snaps to
     the nearest 0/180deg and a gsap.to eases rotY to that settle. Click without
     a real drag navigates to the link. One-time auto-nudge hint to -30 and back.
     Keyboard: Enter/Space activates the link. GSAP loads only when in view +
     reduced-motion off; otherwise the CSS/static fallback stays untouched and
     click still navigates. */
  /* ── Fail-safe reveal arming ──
     The reveal CSS (opacity:0 / clip) now applies ONLY when the section
     carries .obt-armed. Without JS the content is fully visible (no hidden
     state). With JS we arm the section so the CSS reveal animation runs,
     then a safety timeout force-reveals everything if anything stalls
     (theme editor, interrupted load, prefers-reduced-motion). Content is
     never gated on JS, IntersectionObserver, or GSAP. */
  (function () {
    if (window.__obtCtaTicketRevealInit) return;
    window.__obtCtaTicketRevealInit = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function showAll(section) {
      // remove the armed state so no hidden-state CSS can apply; content shows
      section.classList.remove('obt-armed');
    }

    function arm(section) {
      // Static or reduced-motion: never arm — leave content visible as-is.
      if (reduce) return;
      if (section.getAttribute('data-obt-animate') === null) return;

      // Arm: the CSS reveal animation now runs from hidden → visible.
      section.classList.add('obt-armed');

      // Safety net: if the reveal somehow stalls, force everything visible.
      section._obtRevealSafety = setTimeout(function () {
        showAll(section);
      }, 1600);
    }

    function init() {
      var sections = document.querySelectorAll('.obt-cta-ticket[data-obt-animate]');
      for (var i = 0; i < sections.length; i++) arm(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  if (!customElements.get('obt-ticket')) {
    class ObtTicket extends HTMLElement {
      connectedCallback() {
        this.front = this.querySelector('.obt-cta-ticket__face--front');
        this.back = this.querySelector('.obt-cta-ticket__face--back');
        this.stub = this.querySelector('.obt-cta-ticket__stub');
        if (!this.front || !this.back) return;

        this.link = this.dataset.link || '';
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.staticMode = this.dataset.static === 'on' || this.reduce;

        this.rotY = 0;
        this.hovered = false;
        this.interacted = false;
        this.dragging = false;
        this.gsap = null;
        this.draggable = null;
        this.settleTween = null;

        this._apply = this._apply.bind(this);

        this._apply();

        // keyboard activation always works (a11y)
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this._go();
          }
        });

        if (this.staticMode) {
          // no 3D drag; tap/click navigates. Never load GSAP under reduced-motion.
          this.style.cursor = this.link ? 'pointer' : 'default';
          this.addEventListener('click', () => this._go());
          return;
        }

        this.addEventListener('mouseenter', () => this._setHover(true));
        this.addEventListener('mouseleave', () => { if (!this.dragging) this._setHover(false); });

        // Click without an actual drag → navigate. Draggable suppresses the
        // synthetic click after a real drag, so this only fires on a clean tap.
        this.addEventListener('click', () => { if (!this.dragging) this._go(); });

        // Lazy-init GSAP Draggable only when the ticket is in view.
        this.inView = false;
        this._initWhenVisible();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.settleTween) this.settleTween.kill();
        if (this.draggable) { this.draggable.kill(); this.draggable = null; }
        clearTimeout(this._hint);
      }

      _initWhenVisible() {
        const start = () => {
          if (this._booted) return;
          this._booted = true;
          window.obtLoadGsap(['Draggable']).then((gsap) => this._boot(gsap));
        };
        if (!('IntersectionObserver' in window)) { start(); return; }
        this.io = new IntersectionObserver((es) => {
          if (es[0].isIntersecting) { this.inView = true; this.io.disconnect(); start(); }
        }, { threshold: 0 });
        this.io.observe(this);
      }

      _boot(gsap) {
        if (!gsap || !window.Draggable) return;
        this.gsap = gsap;

        // Invisible proxy whose 2D rotation Draggable drives; we read it each
        // tick and project onto the ticket's 3D rotateY.
        this.proxy = document.createElement('div');
        this.proxy.style.position = 'absolute';
        this.proxy.style.width = '1px';
        this.proxy.style.height = '1px';
        this.proxy.style.pointerEvents = 'none';
        this.proxy.style.opacity = '0';
        this.appendChild(this.proxy);
        gsap.set(this.proxy, { rotation: 0 });

        const self = this;
        this.draggable = window.Draggable.create(this.proxy, {
          type: 'rotation',
          trigger: this,
          inertia: false,
          // momentum-like settle: snap proxy rotation to nearest 0/180 multiple
          snap: { rotation: (v) => Math.round(v / 180) * 180 },
          onPressInit() {
            self.interacted = true;
            if (self.settleTween) self.settleTween.kill();
            self._setHover(true);
            self.style.cursor = 'grabbing';
          },
          onDrag() {
            self.dragging = true;
            self.rotY = this.rotation;
            self._apply();
          },
          onDragEnd() {
            self.style.cursor = 'grab';
            const target = Math.round(this.rotation / 180) * 180;
            self._settleTo(target);
            // clear the drag flag after the suppressed click would have fired
            setTimeout(() => { self.dragging = false; }, 0);
          }
        })[0];

        // one-time hint nudge
        this._hint = setTimeout(() => {
          if (this.interacted) return;
          this._settleTo(-30, 0.45);
          setTimeout(() => { if (!this.interacted) this._settleTo(0, 0.45); }, 680);
        }, 1500);
      }

      _go() {
        if (this.link) window.location.href = this.link;
      }

      _apply() {
        const tilt = this.hovered ? '' : ' rotateX(6deg)';
        const lift = this.hovered ? ' translateY(-14px) scale(1.04)' : '';
        this.style.transform = 'rotateY(' + this.rotY + 'deg)' + tilt + lift;
        const m = ((this.rotY % 360) + 360) % 360;
        const showBack = (m > 90 && m < 270);
        this.front.style.opacity = showBack ? '0' : '1';
        this.back.style.opacity = showBack ? '1' : '0';
      }

      _setHover(h) {
        this.hovered = h;
        if (this.stub) {
          this.stub.style.maxHeight = h ? '182px' : '52px';
          this.stub.style.transform = h ? 'rotate(-4.4deg) translate(-6px,11px)' : 'rotate(0deg) translate(0,0)';
          this.stub.style.boxShadow = h ? '0 28px 44px rgba(20,12,4,0.36)' : '0 0 0 rgba(0,0,0,0)';
        }
        this._apply();
      }

      // gsap.to eased settle: tween rotY (and keep proxy in sync) to target.
      _settleTo(target, dur) {
        if (!this.gsap) { this.rotY = target; this._apply(); return; }
        if (this.settleTween) this.settleTween.kill();
        const state = { v: this.rotY };
        this.settleTween = this.gsap.to(state, {
          v: target,
          duration: dur || 0.62,
          ease: 'power3.out',
          onUpdate: () => { this.rotY = state.v; this._apply(); },
          onComplete: () => {
            if (this.proxy && this.draggable) {
              this.gsap.set(this.proxy, { rotation: target });
              this.draggable.update();
            }
          }
        });
      }
    }
    customElements.define('obt-ticket', ObtTicket);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-curriculum"] && !Shopify.designMode) return;
  try {
    
  /* obt-curriculum — vanilla custom element.
     Scroll-reveal for [data-reveal-item] children with a staggered delay.
     IntersectionObserver one-shot; reduced-motion aware; reads stagger from
     the section's --obt-anim-stagger custom property. NO Liquid. */
  if (!customElements.get('obt-curriculum')) {
    class ObtCurriculum extends HTMLElement {
      connectedCallback() {
        if (this.dataset.reveal === 'off') {
          this._showAll();
          return;
        }
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          this._showAll();
          return;
        }

        this.items = Array.from(this.querySelectorAll('[data-reveal-item]'));
        if (!this.items.length) return;

        const cs = getComputedStyle(this);
        const stagger = parseFloat(cs.getPropertyValue('--obt-anim-stagger')) || 80;

        if (!('IntersectionObserver' in window)) {
          this._showAll();
          return;
        }

        /* Arm only now: applies the opacity:0 hidden state via CSS. Without JS
           this class is never added, so content is visible by default. */
        this.classList.add('obt-armed');

        this.io = new IntersectionObserver((entries, obs) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const el = entry.target;
            const i = this.items.indexOf(el);
            el.style.setProperty('--obt-item-delay', Math.max(0, i) * stagger + 'ms');
            el.classList.add('is-visible');
            obs.unobserve(el);
          }
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

        for (const el of this.items) this.io.observe(el);

        /* Safety net: if the observer never fires (theme editor, odd loads),
           force-reveal everything so the section can never stay blank. */
        this._safety = setTimeout(() => this._showAll(), 1600);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this._safety) clearTimeout(this._safety);
      }

      _showAll() {
        for (const el of this.querySelectorAll('[data-reveal-item]')) {
          el.classList.add('is-visible');
        }
      }
    }
    customElements.define('obt-curriculum', ObtCurriculum);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-obt-gate]');
    if (!root) return;

    /* The show/hide DECISION now runs in an inline script at the gate's DOM
       position (above) so the gate opens before the hero paints — no flash.
       By the time this deferred bundle runs, the inline script has either
       removed the gate (so querySelector above is null and we already bailed)
       or opened it and stamped data-armed. If for any reason it is present but
       not open, do nothing. We claim the gate so the inline safety-net stands
       down, then wire the real canvas + reverse-ripple exit. */
    if (!root.classList.contains('is-open')) { return; }
    root.__gateWired = true;

    var btn = root.querySelector('[data-gate-enter]');
    if (btn) btn.focus({ preventScroll: true });

    root.addEventListener('keydown', function (ev) {
      if (ev.key === 'Tab' && btn) { ev.preventDefault(); btn.focus(); }
      if (ev.key === 'Escape') exitGate();
    });

    /* ── canvas field ── */
    var cv = root.querySelector('[data-gate-canvas]');
    var ctx = cv && cv.getContext ? cv.getContext('2d') : null;
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, candles = [], centerI = 0, maxDist = 1;
    var t0 = performance.now();
    var introDone = false, exiting = false, exitAt = 0, gone = false;
    var raf = 0, running = true;
    var px = 0, tx = 0, nextTick = 0;

    var GREEN = '#1FA938', GREEN_DK = '#157A2B';

    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function clamp01(t) { return t < 0 ? 0 : t > 1 ? 1 : t; }

    function build() {
      W = root.clientWidth; H = root.clientHeight;
      cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);

      candles = [];
      var step = Math.max(19, Math.min(34, W / 36));
      var cw = step * 0.56;
      var n = Math.ceil(W / step) + 2;
      centerI = Math.floor(n / 2);
      maxDist = Math.max(centerI, n - 1 - centerI);
      var mid = H * 0.5, amp = Math.min(H * 0.17, 190);

      var raw = [], price = 0;
      for (var i = 0; i < n; i++) {
        var drift = (Math.random() - 0.48) * 2;
        var o = price, c = price + drift * 0.9;
        raw.push({ o: o, c: c, h: Math.max(o, c) + Math.random() * 0.55, l: Math.min(o, c) - Math.random() * 0.55 });
        price = c;
      }
      raw[centerI].c = raw[centerI].o + 1.15; /* the ONE BAR is always up */
      raw[centerI].h = raw[centerI].c + 0.4;
      raw[centerI].l = raw[centerI].o - 0.35;

      var min = Infinity, max = -Infinity;
      raw.forEach(function (k) { min = Math.min(min, k.l); max = Math.max(max, k.h); });
      var span = Math.max(1e-6, max - min);
      function Y(v) { return mid - ((v - min) / span - 0.5) * 2 * amp; }

      for (var j = 0; j < n; j++) {
        var k = raw[j], d = Math.abs(j - centerI);
        candles.push({
          x: j * step + step / 2,
          w: cw,
          o: Y(k.o), c: Y(k.c), h: Y(k.h), l: Y(k.l),
          d: d,
          delay: introDone ? 0 : (j === centerI ? 250 : 1250 + d * 52),
          dur: introDone ? 1 : (j === centerI ? 900 : 620),
          seed: Math.random() * 6.283,
          spd: 0.7 + Math.random() * 0.7,
          a1: 3 + Math.random() * 4.2,
          a2: 1.8 + Math.random() * 2.4,
          pop: null
        });
      }
    }

    function drawCandle(c, p, now, hero) {
      if (p <= 0) return;
      var t = now * 0.001;
      /* continuous multi-frequency drift — every candle moves, always, on its
         own phase, so the field never settles or visibly repeats */
      var drift = (Math.sin(t * 1.05 * c.spd + c.seed) * c.a1
                 + Math.sin(t * 0.58 * c.spd + c.seed * 1.9) * c.a2) * p;
      /* body breathes, like a live print forming */
      var bScale = 1 + 0.17 * Math.sin(t * 1.35 * c.spd + c.seed * 0.7);
      /* brief self-resetting "print" pop (bounded — no drift accumulation) */
      var pop = 0;
      if (c.pop) {
        var pq = clamp01((now - c.pop.start) / c.pop.dur);
        pop = Math.sin(pq * 3.14159) * c.pop.mag;
        if (pq >= 1) c.pop = null;
      }
      var up = c.c <= c.o;
      var top = Math.min(c.o, c.c), bot = Math.max(c.o, c.c);
      var midY = (top + bot) / 2 + drift;
      var half = (Math.max(1.2, (bot - top) / 2) * bScale + pop) * p;
      var wickBreath = (hero ? 3.2 : 2.2) * (0.55 + 0.45 * Math.sin(t * 1.6 * c.spd + c.seed * 1.3));
      var hiY = c.h + drift - wickBreath;
      var loY = c.l + drift + wickBreath;
      var wickP = clamp01(p * 1.5);
      var hw = c.w / 2;

      ctx.save();
      if (hero) {
        ctx.shadowColor = 'rgba(31,169,56,' + (0.34 + 0.16 * Math.sin(now * 0.0022)) + ')';
        ctx.shadowBlur = 24;
        ctx.strokeStyle = GREEN_DK;
        ctx.fillStyle = GREEN;
      } else if (up) {
        ctx.strokeStyle = 'rgba(23,68,42,0.38)';
        ctx.fillStyle = 'rgba(31,169,56,0.10)';
      } else {
        ctx.strokeStyle = 'rgba(96,26,36,0.34)';
        ctx.fillStyle = 'rgba(200,16,46,0.08)';
      }
      ctx.lineWidth = hero ? 1.6 : 1;

      /* wick grows out from the middle */
      ctx.beginPath();
      ctx.moveTo(c.x, midY - (midY - hiY) * wickP);
      ctx.lineTo(c.x, midY + (loY - midY) * wickP);
      ctx.stroke();

      /* body grows out from the middle */
      var bx = c.x - hw, by = midY - half, bw = c.w, bh = half * 2;
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(bx, by, bw, bh, 2.5); else ctx.rect(bx, by, bw, bh);
      ctx.fill();
      ctx.stroke();
      ctx.restore();
    }

    function draw(now) {
      if (gone) return;
      raf = requestAnimationFrame(draw);
      if (!running) return;
      var e = now - t0;
      if (!introDone && e > 1250 + maxDist * 52 + 700) introDone = true;

      ctx.clearRect(0, 0, W, H);

      /* hairline grid */
      ctx.strokeStyle = 'rgba(12,31,20,0.045)';
      ctx.lineWidth = 1;
      for (var g = 1; g <= 4; g++) {
        var gy = H * g * 0.2;
        ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke();
      }

      /* live "prints" — frequent, self-resetting pops so the field is never
         still (bounded: each pop resolves back to 0, no accumulation) */
      if (introDone && !exiting && now > nextTick) {
        nextTick = now + 240 + Math.random() * 520;
        var pick = candles[Math.floor(Math.random() * candles.length)];
        if (pick) pick.pop = { start: now, dur: 520 + Math.random() * 360, mag: 4 + Math.random() * 7 };
      }

      px += (tx - px) * 0.06;
      ctx.save();
      ctx.translate(px, 0);

      for (var i = 0; i < candles.length; i++) {
        var c = candles[i];
        var p = ease(clamp01((e - c.delay) / c.dur));
        if (exiting) {
          var rev = ease(clamp01((now - exitAt - (maxDist - c.d) * 24) / 420));
          p = p * (1 - rev);
        }
        drawCandle(c, p, now, c.d === 0);
      }
      ctx.restore();
    }

    function onMove(ev) {
      var cx = ev.touches ? ev.touches[0].clientX : ev.clientX;
      tx = (cx / W - 0.5) * 14;
    }

    /* ── exit ── */
    function exitGate() {
      if (exiting) return;
      exiting = true;
      exitAt = performance.now();
      try { window.sessionStorage.setItem('obtGateSeen', '1'); } catch (e) {}
      try { window.localStorage.setItem('obtGateSeen', '1'); } catch (e) {}
      root.classList.add('is-exit');
      window.setTimeout(function () {
        gone = true;
        cancelAnimationFrame(raf);
        document.documentElement.classList.remove('obt-gate-lock');
        /* release page-lifetime listeners so the detached node + canvas
           backing store can be collected (no retained-memory leak) */
        window.removeEventListener('resize', onResize);
        document.removeEventListener('visibilitychange', onVis);
        root.remove();
        candles = null;
      }, 1120);
    }
    if (btn) btn.addEventListener('click', exitGate);
    /* the inline safety-net script calls this if it ever has to take over */
    root.__gateExit = exitGate;

    function onResize() { if (!gone) build(); }
    function onVis() { running = document.visibilityState === 'visible'; }
    if (ctx) {
      build();
      raf = requestAnimationFrame(draw);
      window.addEventListener('resize', onResize);
      root.addEventListener('pointermove', onMove);
      document.addEventListener('visibilitychange', onVis);
    }

    /* content reveal */
    window.setTimeout(function () {
      root.classList.add('is-ready');

      /* ── AUTO DISMISS ──
         Measured from the moment the copy is actually on screen, not from page
         parse, so the setting means "hold the gate this long after it is
         readable". 0 = require a click (the original behaviour). Never runs in
         the theme editor, where the merchant needs the gate to stay put to edit
         it. A click before the timer fires is harmless: exitGate self-guards. */
      var autoMs = parseInt(root.getAttribute('data-auto-dismiss') || '0', 10);
      var inEditor = root.hasAttribute('data-design-mode');
      if (autoMs > 0 && !inEditor) {
        window.setTimeout(function () {
          if (!root.isConnected) return;
          exitGate();
        }, autoMs);
      }
    }, ctx ? 1150 : 150);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeader(root) {
    if (!root || root.dataset.obtHeaderInit === '1') return;
    root.dataset.obtHeaderInit = '1';

    /* stuck state — bind to the REAL scroller (Horizon scrolls .page-wrapper on
       desktop; the window scrolls below 990px), so the shadow deepens on scroll everywhere */
    var head = root.querySelector('[data-obt-head]');
    if (head) {
      var detectScroller = function () {
        var pw = document.querySelector('.page-wrapper');
        if (pw) { var ov = getComputedStyle(pw).overflowY; if (ov === 'auto' || ov === 'scroll') return pw; }
        return window;
      };
      var scroller = detectScroller();
      var readTop = function () { return scroller === window ? (window.scrollY || window.pageYOffset || 0) : scroller.scrollTop; };
      var onScroll = function () { head.classList.toggle('is-stuck', readTop() > 6); };
      onScroll();
      scroller.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        var next = detectScroller();
        if (next !== scroller) { scroller.removeEventListener('scroll', onScroll); scroller = next; scroller.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
      }, { passive: true });
    }

    /* logo → home must never re-open the entrance gate: mark it seen on click
       so the homepage skips the gate (the gate is a first-visit entrance, not a
       toll you pay every time you click the logo) */
    var brand = root.querySelector('a.obt-brand');
    if (brand) {
      brand.addEventListener('click', function () {
        try { window.sessionStorage.setItem('obtGateSeen', '1'); } catch (e) {}
        try { window.localStorage.setItem('obtGateSeen', '1'); } catch (e) {}
      });
    }

    /* mobile drawer open/close */
    var drawer = root.querySelector('[data-obt-drawer]');
    var burger = root.querySelector('[data-obt-burger]');
    var openDrawer = function () {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closeDrawer = function () {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if ((e.target.hasAttribute && e.target.hasAttribute('data-obt-dclose')) || e.target.closest('a')) closeDrawer();
      });
      var mobileMegas = drawer.querySelectorAll('[data-mobile-mega]');
      mobileMegas.forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          mobileMegas.forEach(function (other) { if (other !== details) other.open = false; });
        });
      });
    }

    /* mega-menu dropdown open/close (click + keyboard), one open at a time */
    var items = root.querySelectorAll('.obt-nav__item[data-mega]');
    var closeAllMega = function (except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var t = it.querySelector('.obt-nav__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    };
    items.forEach(function (item) {
      var trigger = item.querySelector('.obt-nav__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        closeAllMega(item);
        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    /* Escape closes drawer + any open mega-menu, then blurs focus */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && drawer.classList.contains('is-open')) { closeDrawer(); return; }
      var anyOpen = false;
      items.forEach(function (it) { if (it.classList.contains('is-open')) anyOpen = true; });
      if (anyOpen) { closeAllMega(null); return; }
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    });

    /* click outside closes open mega-menus */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.obt-nav__item[data-mega]')) closeAllMega(null);
    });
  }

  function boot() {
    document.querySelectorAll('.obt-header').forEach(initHeader);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('.obt-header').forEach(initHeader);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-hero"] && !Shopify.designMode) return;
  try {
    
/* ONEBAR hero v2 — gate-synced replay, count-up metrics, magnetic CTA,
   pointer parallax. Entrance itself is pure CSS; this only re-triggers it
   when the entrance gate lifts, and adds optional GSAP sugar.
   No Liquid. Reduced-motion aware. Multi-instance + editor-reload safe. */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function parseCount(txt) {
    var m = txt.match(/^([^0-9]*)([0-9][0-9\s.,]*)(.*)$/);
    if (!m) return null;
    var num = parseFloat(m[2].replace(/[^\d.]/g, ''));
    if (!isFinite(num) || num <= 0) return null;
    return { pre: m[1], num: num, suf: m[3] };
  }

  function animateCount(el) {
    var fin = el.getAttribute('data-h-final');
    if (!fin) { fin = el.textContent; el.setAttribute('data-h-final', fin); }
    var p = parseCount(fin);
    if (!p) return;
    var t0 = performance.now(), dur = 1500;
    function tick() {
      var t = Math.min(1, (performance.now() - t0) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      var v = p.num * e;
      el.textContent = p.pre + (p.num < 20 ? (Math.round(v * 10) / 10) : Math.round(v)) + p.suf;
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = fin;
    }
    requestAnimationFrame(tick);
  }

  function initHero(root) {
    if (root.getAttribute('data-h-init')) return;
    root.setAttribute('data-h-init', '1');

    var els = Array.prototype.slice.call(root.querySelectorAll('[data-h-in]'));
    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-h-count]'));
    var started = false;

    function runCounters(delay) {
      if (started) return;
      started = true;
      if (REDUCE) return; /* numbers already carry their final text */
      window.setTimeout(function () { counters.forEach(animateCount); }, delay || 350);
    }

    /* ── gate coordination: replay the entrance as the white lifts ── */
    var gate = document.querySelector('.obt-gate');
    if (!gate || REDUCE) {
      runCounters(550);
    } else {
      var wasOpen = gate.classList.contains('is-open');
      var replayed = false;
      function holdThenReplay() {
        if (replayed) return;
        replayed = true;
        root.classList.add('is-wait');
        els.forEach(function (el) { el.style.animation = 'none'; });
        window.setTimeout(function () {
          root.classList.remove('is-wait');
          void root.offsetWidth;
          els.forEach(function (el) { el.style.animation = ''; });
          /* rewind EVERY CSS animation in the hero (equity loop, entry
             annotation, step cycle, marquee) so the whole show starts from
             zero the moment the gate's white lifts — not midway through */
          if (root.getAnimations) {
            root.getAnimations({ subtree: true }).forEach(function (a) {
              try { if (a.animationName) a.currentTime = 0; } catch (e) {}
            });
          }
          runCounters(950);
        }, 600);
      }
      var mo = new MutationObserver(function () {
        if (!gate.isConnected) {
          mo.disconnect(); po.disconnect();
          if (wasOpen) holdThenReplay(); else runCounters(250);
          return;
        }
        if (gate.classList.contains('is-open')) wasOpen = true;
        if (wasOpen && gate.classList.contains('is-exit')) holdThenReplay();
      });
      mo.observe(gate, { attributes: true, attributeFilter: ['class'] });
      var po = new MutationObserver(function () {
        if (!gate.isConnected) {
          mo.disconnect(); po.disconnect();
          if (wasOpen && !replayed) holdThenReplay(); else if (!wasOpen) runCounters(250);
        }
      });
      po.observe(gate.parentNode || document.body, { childList: true, subtree: false });
    }

    if (REDUCE || !FINE) return;

    /* ── magnetic primary CTA (GSAP sugar) ── */
    var mag = root.querySelector('[data-h-mag]');
    if (mag && window.gsap) {
      var mx = window.gsap.quickTo(mag, 'x', { duration: .4, ease: 'power3' });
      var my = window.gsap.quickTo(mag, 'y', { duration: .4, ease: 'power3' });
      mag.addEventListener('mousemove', function (ev) {
        var r = mag.getBoundingClientRect();
        mx((ev.clientX - r.left - r.width / 2) * .16);
        my((ev.clientY - r.top - r.height / 2) * .3);
      });
      mag.addEventListener('mouseleave', function () { mx(0); my(0); });
    }

    /* ── pointer parallax: color fields + gentle panel tilt ── */
    if (window.gsap) {
      var pars = Array.prototype.slice.call(root.querySelectorAll('[data-h-par]')).map(function (el) {
        return {
          d: parseFloat(el.getAttribute('data-h-par')) || 12,
          x: window.gsap.quickTo(el, 'x', { duration: .9, ease: 'power2' }),
          y: window.gsap.quickTo(el, 'y', { duration: .9, ease: 'power2' })
        };
      });
      var tilt = root.querySelector('[data-h-tilt]');
      var tRX, tRY;
      if (tilt) {
        tRX = window.gsap.quickTo(tilt, 'rotationX', { duration: .8, ease: 'power2' });
        tRY = window.gsap.quickTo(tilt, 'rotationY', { duration: .8, ease: 'power2' });
        window.gsap.set(tilt, { transformPerspective: 900 });
      }
      root.addEventListener('pointermove', function (ev) {
        var r = root.getBoundingClientRect();
        var nx = (ev.clientX - r.left) / r.width - .5;
        var ny = (ev.clientY - r.top) / r.height - .5;
        pars.forEach(function (p) { p.x(nx * p.d); p.y(ny * p.d * .7); });
        if (tilt) { tRY(nx * 2.4); tRX(ny * -1.8); }
      });
      root.addEventListener('pointerleave', function () {
        pars.forEach(function (p) { p.x(0); p.y(0); });
        if (tilt) { tRY(0); tRX(0); }
      });
    }
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-obt-hero]'), initHero);
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-lead-magnet"] && !Shopify.designMode) return;
  try {
    
  /* obt-reveal — vanilla custom element.
     Adds .is-visible to the host section once the panel scrolls into view,
     so the CSS reveal animation fires on scroll. IntersectionObserver only,
     reduced-motion aware, no layout animation. If scroll-gating is off the
     CSS reveals on load and this stays a no-op. NO Liquid. */
  if (!customElements.get('obt-reveal')) {
    class ObtReveal extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.obt-lead-magnet');
        if (!this.section) return;
        if (this.section.dataset.obtOnScroll !== 'true') return;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          this.section.classList.add('is-visible');
          return;
        }

        if (!('IntersectionObserver' in window)) {
          this.section.classList.add('is-visible');
          return;
        }

        // Animated path: arm the hidden state ONLY now that JS is running and
        // can guarantee a reveal. Without this class the CSS never sets
        // opacity:0, so a stalled IO can never leave the panel blank.
        this.section.classList.add('obt-armed');

        this.io = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this._showAll();
              break;
            }
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
        this.io.observe(this);

        // Safety net: if the observer never fires (some storefront loads,
        // tabbed-away loads), force-reveal so the section is never blank.
        this.safety = setTimeout(() => this._showAll(), 1600);
      }

      _showAll() {
        if (this.section) this.section.classList.add('is-visible');
        if (this.io) {
          this.io.disconnect();
          this.io = null;
        }
        if (this.safety) {
          clearTimeout(this.safety);
          this.safety = null;
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.safety) clearTimeout(this.safety);
      }
    }
    customElements.define('obt-reveal', ObtReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-manifesto"] && !Shopify.designMode) return;
  try {
    
  /* obt-manifesto — interactive dot field + word-by-word quote reveal.
     One canvas per card carries both the dots and the word particles.
     Pointer events cover mouse AND touch; a tap fires a ripple ring.
     IntersectionObserver drives the reveal (Horizon scrolls .page-wrapper,
     not window — ScrollTrigger-style window scroll would never fire) and a
     failsafe timeout guarantees the text always ends visible.
     Reduced-motion: no canvas, no reveal — the static CSS card stands. */
  (function () {
    var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parseColor(str) {
      str = (str || '').trim();
      if (str[0] === '#') {
        var h = str.slice(1);
        if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
        var n = parseInt(h.slice(0, 6), 16);
        if (!isNaN(n)) return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
      }
      var m = str.match(/(\d+(?:\.\d+)?)[,\s]+(\d+(?:\.\d+)?)[,\s]+(\d+(?:\.\d+)?)/);
      if (m) return [+m[1], +m[2], +m[3]];
      return [200, 16, 46];
    }

    /* ---- canvas engine: dot grid + ripples + word particles ---- */
    function createCanvasFx(fig, opts) {
      var cv = fig.querySelector('[data-obt-cv]');
      if (!cv || !cv.getContext) return null;
      var ctx = cv.getContext('2d');
      if (!ctx) return null;

      var SPACING = 16, DOT_R = 1.4, BASE_A = 0.17;
      var PUSH_RADIUS = 150, PUSH_MAX = 17;
      var dots = [], ripples = [], particles = [];
      var pointer = { x: 0, y: 0, on: false };
      var W = 0, H = 0, dpr = 1, running = false, colors = null;

      function refreshColors() {
        var cs = getComputedStyle(fig);
        colors = {
          dot: parseColor(cs.getPropertyValue('--obt-red')),
          soft: parseColor(cs.getPropertyValue('--ink-soft'))
        };
      }

      function build() {
        var r = fig.getBoundingClientRect();
        W = Math.max(1, Math.round(r.width));
        H = Math.max(1, Math.round(r.height));
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        cv.width = W * dpr;
        cv.height = H * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        dots.length = 0;
        for (var y = SPACING / 2; y < H; y += SPACING) {
          for (var x = SPACING / 2; x < W; x += SPACING) {
            dots.push({ bx: x, by: y, dx: 0, dy: 0, a: BASE_A });
          }
        }
        draw(0);
      }

      function rgba(c, a) {
        return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')';
      }

      var lastT = 0;
      function draw(t) {
        ctx.clearRect(0, 0, W, H);
        var calm = !pointer.on;
        var i, d;

        if (opts.dots) {
          for (i = 0; i < dots.length; i++) {
            d = dots[i];
            var tx = 0, ty = 0, boost = 0;

            if (pointer.on) {
              var ddx = d.bx - pointer.x, ddy = d.by - pointer.y;
              var dist = Math.sqrt(ddx * ddx + ddy * ddy) || 1;
              if (dist < PUSH_RADIUS) {
                var f = 1 - dist / PUSH_RADIUS, f2 = f * f;
                tx += (ddx / dist) * f2 * PUSH_MAX;
                ty += (ddy / dist) * f2 * PUSH_MAX;
                var wave = Math.sin(dist / 22 - t * 4.2) * 0.5 + 0.5;
                boost = Math.max(boost, f2 * (0.22 + wave * 0.55));
              }
            }
            for (var k = 0; k < ripples.length; k++) {
              var rp = ripples[k];
              var rdx = d.bx - rp.x, rdy = d.by - rp.y;
              var rd = Math.sqrt(rdx * rdx + rdy * rdy) || 1;
              var band = (rd - rp.r) / 30;
              var g = Math.exp(-band * band);
              if (g > 0.02) {
                tx += (rdx / rd) * g * 16 * rp.a;
                ty += (rdy / rd) * g * 16 * rp.a;
                boost = Math.max(boost, g * rp.a * 0.75);
              }
            }

            d.dx += (tx - d.dx) * 0.14;
            d.dy += (ty - d.dy) * 0.14;
            d.a += (BASE_A + boost * 0.75 - d.a) * 0.18;
            if (calm && (Math.abs(d.dx) > 0.25 || Math.abs(d.dy) > 0.25 || Math.abs(d.a - BASE_A) > 0.01)) calm = false;

            ctx.fillStyle = rgba(colors.dot, Math.min(d.a, 0.92));
            ctx.beginPath();
            ctx.arc(d.bx + d.dx, d.by + d.dy, DOT_R, 0, 6.2832);
            ctx.fill();
          }
        }

        var dt = Math.min(t - lastT || 0.016, 0.05);
        lastT = t;

        for (i = ripples.length - 1; i >= 0; i--) {
          var rr = ripples[i];
          rr.r += 340 * dt;
          rr.a *= 0.955;
          if (rr.a < 0.02) ripples.splice(i, 1);
        }
        for (i = particles.length - 1; i >= 0; i--) {
          var p = particles[i];
          p.life += dt;
          if (p.life >= p.max) { particles.splice(i, 1); continue; }
          p.vx *= 0.97;
          p.vy = p.vy * 0.97 - 14 * dt;
          p.x += p.vx * dt;
          p.y += p.vy * dt;
          var pa = 1 - p.life / p.max;
          ctx.fillStyle = rgba(p.c, pa * pa * 0.85);
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.s * (0.6 + pa * 0.4), 0, 6.2832);
          ctx.fill();
        }

        return calm && !ripples.length && !particles.length;
      }

      function loop(now) {
        if (draw(now / 1000)) { running = false; return; }
        requestAnimationFrame(loop);
      }
      function ensure() {
        if (running) return;
        running = true;
        requestAnimationFrame(loop);
      }

      if (opts.dots) {
        fig.addEventListener('pointerenter', function (e) {
          var r = fig.getBoundingClientRect();
          pointer.x = e.clientX - r.left;
          pointer.y = e.clientY - r.top;
          pointer.on = true;
          ensure();
        });
        fig.addEventListener('pointermove', function (e) {
          var r = fig.getBoundingClientRect();
          pointer.x = e.clientX - r.left;
          pointer.y = e.clientY - r.top;
          pointer.on = true;
          ensure();
        }, { passive: true });
        fig.addEventListener('pointerdown', function (e) {
          var r = fig.getBoundingClientRect();
          if (ripples.length < 6) {
            ripples.push({ x: e.clientX - r.left, y: e.clientY - r.top, r: 4, a: 1 });
          }
          ensure();
        }, { passive: true });
        var off = function () { pointer.on = false; ensure(); };
        fig.addEventListener('pointerleave', off);
        fig.addEventListener('pointercancel', off);
        fig.classList.add('is-canvas');
      }

      refreshColors();
      build();

      if ('ResizeObserver' in window) {
        var pending = false;
        new ResizeObserver(function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () { pending = false; build(); });
        }).observe(fig);
      } else {
        window.addEventListener('resize', build);
      }
      new MutationObserver(function () { refreshColors(); ensure(); })
        .observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });

      return {
        burst: function (x, y) {
          if (particles.length > 90) return;
          for (var i = 0; i < 3; i++) {
            var ang = (-90 + (Math.random() * 110 - 55)) * Math.PI / 180;
            var sp = 40 + Math.random() * 55;
            particles.push({
              x: x + (Math.random() * 18 - 9),
              y: y + (Math.random() * 8 - 4),
              vx: Math.cos(ang) * sp,
              vy: Math.sin(ang) * sp,
              life: 0,
              max: 0.7 + Math.random() * 0.45,
              s: 1.5 + Math.random() * 1.1,
              c: i === 2 ? colors.soft : colors.dot
            });
          }
          ensure();
        }
      };
    }

    /* ---- word-by-word reveal (IO + failsafe; never leaves text hidden) ---- */
    function initWords(sec, fig, fx) {
      var bq = fig.querySelector('[data-obt-quote]');
      if (!bq || !('IntersectionObserver' in window)) return;

      var words = [];
      (function wrap(node) {
        var kids = Array.prototype.slice.call(node.childNodes);
        kids.forEach(function (k) {
          if (k.nodeType === 3) {
            var parts = k.textContent.split(/(\s+)/);
            if (parts.length < 2 && !parts[0].trim()) return;
            var frag = document.createDocumentFragment();
            parts.forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) {
                frag.appendChild(document.createTextNode(p));
              } else {
                var s = document.createElement('span');
                s.className = 'obt-manifesto__w';
                s.textContent = p;
                words.push(s);
                frag.appendChild(s);
              }
            });
            node.replaceChild(frag, k);
          } else if (k.nodeType === 1) {
            wrap(k);
          }
        });
      })(bq);
      if (!words.length) return;

      var stagger = parseInt(sec.getAttribute('data-stagger'), 10) || 55;
      var wantParticles = sec.hasAttribute('data-particles') && fx;
      var attribution = fig.querySelector('.obt-manifesto__by');
      fig.classList.add('is-words-armed');

      var played = false;
      function reveal() {
        if (played) return;
        played = true;
        words.forEach(function (w, i) {
          setTimeout(function () {
            w.classList.add('is-in');
            if (wantParticles && i % 2 === 0) {
              var wr = w.getBoundingClientRect();
              var fr = fig.getBoundingClientRect();
              fx.burst(wr.left - fr.left + wr.width / 2, wr.top - fr.top + wr.height * 0.3);
            }
          }, i * stagger);
        });
        if (attribution) {
          setTimeout(function () { attribution.classList.add('is-in'); }, words.length * stagger + 260);
        }
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { reveal(); io.disconnect(); }
        });
      }, { threshold: 0.3 });
      io.observe(bq);
      /* guarded: a blanket timer used to fire this on a page the visitor had
         not scrolled to yet, so the quote was already revealed on arrival */
      setTimeout(function () {
        if (bq.getBoundingClientRect().top < (window.innerHeight || 0)) reveal();
      }, 3200);
    }

    function setup(sec) {
      if (sec.dataset.obtManiInit) return;
      sec.dataset.obtManiInit = '1';

      /* pause the runner's gallop while the card is off screen. Decoration
         only — if this never runs, the loop simply keeps going. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          sec.classList.toggle('is-off', !es[0].isIntersecting);
        }, { threshold: 0 }).observe(sec);
      }

      if (REDUCE) return;
      var fig = sec.querySelector('.obt-manifesto__quote');
      if (!fig) return;
      var wantDots = sec.hasAttribute('data-dots');
      var wantParticles = sec.hasAttribute('data-particles');
      var fx = (wantDots || wantParticles) ? createCanvasFx(fig, { dots: wantDots }) : null;
      if (sec.hasAttribute('data-words')) initWords(sec, fig, fx);
    }

    function boot() {
      document.querySelectorAll('.obt-manifesto').forEach(setup);
    }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('.obt-manifesto').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-market-board"] && !Shopify.designMode) return;
  try {
    
  /* ════════════════════════════════════════════════════════════════════
     obt-candles — vanilla 2D canvas pixel candlestick chart.
     Pixel grid CELL px; candle UNIT = 4 cols (3 body + 1 gap). Price axis
     locked LO=24..HI=176. baseAt(i)=100+36*sin(i*0.15)+13*sin(i*0.52+1.1).
     open = prev close. A new candle is pushed every `speed` ms (oldest
     dropped) so the chart marches left. Wick 3px dim flicker; body 3 cols
     green if close>=open else red, ~0.82 alpha. IntersectionObserver pause,
     devicePixelRatio capped at 2. NO Liquid, NO libraries.
     ════════════════════════════════════════════════════════════════════ */
  if (!customElements.get('obt-candles')) {
    var LO = 24, HI = 176, CELL_DEFAULT = 11, UNIT = 4, BODY_COLS = 3, WICK_W = 3;

    function baseAt(i) {
      return 100 + 36 * Math.sin(i * 0.15) + 13 * Math.sin(i * 0.52 + 1.1);
    }

    class ObtCandles extends HTMLElement {
      connectedCallback() {
        this.cell = parseFloat(this.dataset.cell) || CELL_DEFAULT;
        this.speed = parseFloat(this.dataset.speed) || 560;
        this.up = (this.dataset.up || '#27c06a').trim();
        this.down = (this.dataset.down || '#ec4b34').trim();
        this.staticMode =
          this.dataset.static === 'on' ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
        this.appendChild(this.canvas);

        this.candles = [];
        this.seed = 0;
        this.visible = true;
        this.lastPush = 0;
        this._loop = this._loop.bind(this);

        this._resize();
        this._ro = new ResizeObserver(() => this._resize());
        this._ro.observe(this);

        this._seedFill();

        if (this.staticMode) {
          this._draw();
          return;
        }

        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            if (this.visible && !this.raf) {
              this.lastPush = performance.now();
              this.raf = requestAnimationFrame(this._loop);
            }
          }, { rootMargin: '120px' });
          this._io.observe(this);
        }
        this.lastPush = performance.now();
        this.raf = requestAnimationFrame(this._loop);
      }

      disconnectedCallback() {
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this._io) this._io.disconnect();
        if (this._ro) this._ro.disconnect();
      }

      _resize() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var r = this.getBoundingClientRect();
        this.w = Math.max(1, Math.round(r.width));
        this.h = Math.max(1, Math.round(r.height));
        this.canvas.width = Math.round(this.w * dpr);
        this.canvas.height = Math.round(this.h * dpr);
        this.canvas.style.width = this.w + 'px';
        this.canvas.style.height = this.h + 'px';
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        this.cols = Math.ceil(this.w / this.cell) + UNIT;
        this.maxCandles = Math.ceil(this.cols / UNIT) + 2;
        this._seedFill();
        this._draw();
      }

      _makeCandle(i) {
        var prev = this.candles.length ? this.candles[this.candles.length - 1].close : baseAt(i - 1);
        var open = prev;
        var close = baseAt(i);
        // a little deterministic jitter so bodies vary
        var jitter = (Math.sin(i * 1.7) + Math.sin(i * 0.37)) * 6;
        close = Math.max(LO + 4, Math.min(HI - 4, close + jitter));
        var wickHi = Math.max(open, close) + (4 + ((i * 7) % 9));
        var wickLo = Math.min(open, close) - (4 + ((i * 5) % 9));
        return {
          open: open,
          close: close,
          hi: Math.min(HI, wickHi),
          lo: Math.max(LO, wickLo)
        };
      }

      _seedFill() {
        var need = (this.maxCandles || 24);
        if (this.candles.length >= need) return;
        if (!this.candles.length) this.seed = 0;
        while (this.candles.length < need) {
          this.candles.push(this._makeCandle(this.seed++));
        }
      }

      _push() {
        this.candles.push(this._makeCandle(this.seed++));
        while (this.candles.length > (this.maxCandles || 24)) this.candles.shift();
      }

      _y(price) {
        // map LO..HI onto canvas height, inverted (high price near top)
        var t = (price - LO) / (HI - LO);
        return Math.round(this.h - t * this.h);
      }

      _draw() {
        var ctx = this.ctx;
        if (!ctx) return;
        ctx.clearRect(0, 0, this.w, this.h);

        var n = this.candles.length;
        // newest candle on the right
        for (var k = 0; k < n; k++) {
          var c = this.candles[k];
          var xRight = this.w - (n - 1 - k) * UNIT * this.cell;
          var bodyX = xRight - BODY_COLS * this.cell;
          if (xRight < -UNIT * this.cell) continue;

          var rising = c.close >= c.open;
          var color = rising ? this.up : this.down;

          // wick — dim, slim
          var wickX = bodyX + Math.floor((BODY_COLS * this.cell - WICK_W) / 2);
          ctx.globalAlpha = 0.32 + 0.12 * Math.abs(Math.sin((this.seed + k) * 0.6));
          ctx.fillStyle = color;
          ctx.fillRect(wickX, this._y(c.hi), WICK_W, Math.max(1, this._y(c.lo) - this._y(c.hi)));

          // body — 3 cols, ~0.82 alpha
          ctx.globalAlpha = 0.82;
          var top = this._y(Math.max(c.open, c.close));
          var bot = this._y(Math.min(c.open, c.close));
          ctx.fillRect(bodyX, top, BODY_COLS * this.cell, Math.max(this.cell, bot - top));
        }
        ctx.globalAlpha = 1;
      }

      _loop(now) {
        if (!this.visible) { this.raf = null; return; }
        if (now - this.lastPush >= this.speed) {
          this._push();
          this.lastPush = now;
        }
        this._draw();
        this.raf = requestAnimationFrame(this._loop);
      }
    }
    customElements.define('obt-candles', ObtCandles);
  }

  /* ════════════════════════════════════════════════════════════════════
     obt-flapboard — split-flap departure board. Grid of flap cells; each
     spins through ~spins random glyphs before landing on its target. The
     message resolves diagonally (delay = col*colDelay + row*rowDelay).
     Single-row board sized to the longest message. Flap via CSS rotateX
     keyframe restarted with the reflow trick; stepping via setTimeout refs
     (NOT state). Cycles messages every `cycle` ms. NO Liquid, NO libraries.
     ════════════════════════════════════════════════════════════════════ */
  if (!customElements.get('obt-flapboard')) {
    class ObtFlapboard extends HTMLElement {
      connectedCallback() {
        this.glyphs = (this.dataset.glyphs || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 +-.').split('');
        this.cellW = parseFloat(this.dataset.cellW) || 26;
        this.cellH = parseFloat(this.dataset.cellH) || 38;
        this.spins = Math.max(4, parseInt(this.dataset.spins, 10) || 18);
        this.step = parseFloat(this.dataset.step) || 55;
        this.colDelay = parseFloat(this.dataset.colDelay) || 60;
        this.rowDelay = parseFloat(this.dataset.rowDelay) || 90;
        this.cycle = parseFloat(this.dataset.cycle) || 5200;
        this.staticMode =
          this.dataset.static === 'on' ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var tpls = Array.from(this.querySelectorAll('[data-flap-message]'));
        this.messages = tpls
          .map(function (t) { return (t.textContent || '').trim().toUpperCase(); })
          .filter(Boolean);
        if (!this.messages.length) return;

        // strip the templates / noscript so only flap cells render
        this.innerHTML = '';

        this.cellCount = this.messages.reduce(function (m, s) { return Math.max(m, s.length); }, 0);
        this.cells = [];
        this.timers = [];

        for (var i = 0; i < this.cellCount; i++) {
          var cell = document.createElement('span');
          cell.className = 'obt-market-board__flap';
          cell.style.setProperty('--obt-flap-w', this.cellW + 'px');
          cell.style.setProperty('--obt-flap-h', this.cellH + 'px');
          cell.textContent = ' ';
          this.appendChild(cell);
          this.cells.push(cell);
        }

        this.index = 0;

        if (this.staticMode) {
          this._land(this.messages[0]);
          return;
        }

        this.visible = true;
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            if (this.visible && !this._running) this._start();
          }, { rootMargin: '80px' });
          this._io.observe(this);
        } else {
          this._start();
        }
      }

      disconnectedCallback() {
        this._clearTimers();
        if (this._cycleTimer) clearTimeout(this._cycleTimer);
        if (this._io) this._io.disconnect();
      }

      _clearTimers() {
        for (var i = 0; i < this.timers.length; i++) clearTimeout(this.timers[i]);
        this.timers = [];
      }

      _land(msg) {
        for (var i = 0; i < this.cells.length; i++) {
          this.cells[i].textContent = msg[i] || ' ';
        }
      }

      _start() {
        if (this._running) return;
        this._running = true;
        this._resolve(this.messages[this.index]);
      }

      _rand() {
        return this.glyphs[(Math.random() * this.glyphs.length) | 0] || ' ';
      }

      _spinCell(cell, target, spinsLeft) {
        if (spinsLeft <= 0) {
          cell.textContent = target || ' ';
          cell.classList.remove('obt-market-board__flap--spinning');
          return;
        }
        cell.textContent = this._rand();
        // restart the CSS flip keyframe via the reflow trick
        cell.classList.remove('obt-market-board__flap--spinning');
        void cell.offsetWidth;
        cell.classList.add('obt-market-board__flap--spinning');
        var t = setTimeout(() => this._spinCell(cell, target, spinsLeft - 1), this.step);
        this.timers.push(t);
      }

      _resolve(msg) {
        this._clearTimers();
        var cols = this.cells.length;
        for (var i = 0; i < cols; i++) {
          var target = msg[i] || ' ';
          // diagonal resolve — single row, so col index drives the delay,
          // plus a row term kept for multi-row parity with the source spec
          var delay = i * this.colDelay + (0 * this.rowDelay);
          // each cell does a few extra spins the further right it is
          var spins = this.spins + ((Math.random() * 6) | 0);
          (function (self, cell, tgt, sp) {
            var t = setTimeout(function () { self._spinCell(cell, tgt, sp); }, delay);
            self.timers.push(t);
          })(this, this.cells[i], target, spins);
        }

        // schedule next message
        if (this.messages.length > 1) {
          this._cycleTimer = setTimeout(() => {
            if (!this.visible) { this._running = false; return; }
            this.index = (this.index + 1) % this.messages.length;
            this._resolve(this.messages[this.index]);
          }, this.cycle);
        }
      }
    }
    customElements.define('obt-flapboard', ObtFlapboard);
  }

  /* ════════════════════════════════════════════════════════════════════
     Fail-safe reveal arming. The CSS reveal sets the section content to
     opacity:0 ONLY when the section carries .obt-armed. Without JS the
     class is never added, so content is fully visible by default (theme
     editor, JS errors, blocked scripts). With JS we arm the section so
     the pure-CSS `forwards` reveal animation can play, then a safety
     timeout disarms it — guaranteeing the content can never be left
     stuck at opacity:0 if an animation fails to start. We do NOT arm
     when animation is off or reduced motion is requested.
     ════════════════════════════════════════════════════════════════════ */
  if (!window.__obtMarketBoardArm) {
    window.__obtMarketBoardArm = true;

    var obtMbArm = function (root) {
      var scope = root && root.querySelectorAll ? root : document;
      var nodes = scope.querySelectorAll('.obt-market-board[data-obt-animate]');
      for (var i = 0; i < nodes.length; i++) {
        (function (el) {
          if (el.__obtArmed) return;
          el.__obtArmed = true;

          var reduce = false;
          try {
            reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          } catch (e) {}
          // No animation requested or reduced motion: leave content visible.
          if (el.getAttribute('data-obt-animate') === 'none' || reduce) return;

          el.classList.add('obt-armed');

          // Safety net: if the reveal animation never completes for any
          // reason, force everything visible by disarming.
          var disarm = function () { el.classList.remove('obt-armed'); };
          var safety = setTimeout(disarm, 1600);

          var content = el.querySelector('.obt-market-board__content');
          if (content) {
            var done = 0;
            var total = content.children.length;
            content.addEventListener('animationend', function () {
              done += 1;
              if (done >= total) {
                clearTimeout(safety);
                disarm();
              }
            });
          }
        })(nodes[i]);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { obtMbArm(document); });
    } else {
      obtMbArm(document);
    }
    // Theme editor: arm freshly loaded/reloaded sections.
    document.addEventListener('shopify:section:load', function (e) { obtMbArm(e.target); });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-offerings"] && !Shopify.designMode) return;
  try {
    
/* ══════════════════════════════════════════════════════════════════════════
   obt-offerings deck
   One card on stage at a time: arrows, dots, keyboard, and a real drag with a
   sprung settle. Ships nothing until it runs — the static markup is a plain
   stack of readable cards, and .is-deck is what turns it into a deck.

   ⚠️ No scroll maths anywhere. On Horizon desktop the window does not scroll,
   .page-wrapper does (see project-horizon-scrolltrigger-trap), so this uses
   pointer events and element rects only.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  function boot(root) {
    if (!root || root.dataset.deckReady === '1') return;
    var track = root.querySelector('[data-deck-track]');
    var viewport = root.querySelector('[data-deck-viewport]');
    var slides = [].slice.call(root.querySelectorAll('[data-deck-slide]'));
    if (!track || !viewport || slides.length < 2) return;
    root.dataset.deckReady = '1';

    var prev = root.querySelector('[data-deck-prev]');
    var next = root.querySelector('[data-deck-next]');
    var dots = [].slice.call(root.querySelectorAll('[data-deck-go]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var i = 0;

    root.classList.add('is-deck');
    viewport.setAttribute('aria-roledescription', 'carousel');

    /* stagger index for the copy entrance — set once, not per move */
    slides.forEach(function (s) {
      var kids = s.querySelectorAll('.obt-offerings__body > *');
      for (var k = 0; k < kids.length; k++) kids[k].style.setProperty('--n', k);
    });

    function paint() {
      track.style.setProperty('--i', i);
      track.style.setProperty('--dx', '0px');
      for (var n = 0; n < slides.length; n++) {
        var on = n === i;
        slides[n].classList.toggle('is-live', on);
        /* inert removes it from the tab order AND from hit testing; aria-hidden
           covers the screen readers that do not implement inert yet. Both are
           removed on the live slide or its own CTA becomes unreachable. */
        if (on) { slides[n].removeAttribute('inert'); slides[n].removeAttribute('aria-hidden'); }
        else { slides[n].setAttribute('inert', ''); slides[n].setAttribute('aria-hidden', 'true'); }
      }
      for (var d = 0; d < dots.length; d++) {
        var sel = d === i;
        dots[d].setAttribute('aria-selected', sel ? 'true' : 'false');
        dots[d].tabIndex = sel ? 0 : -1;
        /* the active dot borrows the card's own accent, so the control tells
           you which world you are in without a second colour system */
        if (sel && slides[d]) dots[d].style.setProperty('--dot-acc', slides[d].style.getPropertyValue('--acc') || '');
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function go(n, focus) {
      var clamped = Math.max(0, Math.min(slides.length - 1, n));
      if (clamped === i) { track.style.setProperty('--dx', '0px'); return; }
      i = clamped;
      paint();
      if (focus && dots[i]) dots[i].focus();
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (b) {
      b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-deck-go'), 10) || 0); });
    });

    root.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); go(i - 1, true); }
      else if (ev.key === 'ArrowRight') { ev.preventDefault(); go(i + 1, true); }
    });

    /* ── drag ──
       Rubber-banded at both ends (a third of the pull) so the deck always says
       where it stops. A move counts if it passed 18% of the stage OR was
       flicked faster than 0.45 px/ms — the flick is what makes a short, fast
       swipe feel answered. */
    var down = false, startX = 0, startY = 0, dx = 0, startT = 0, axis = '';
    viewport.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'mouse' && ev.button !== 0) return;
      down = true; axis = ''; dx = 0;
      startX = ev.clientX; startY = ev.clientY; startT = ev.timeStamp;
    });
    viewport.addEventListener('pointermove', function (ev) {
      if (!down) return;
      var mx = ev.clientX - startX, my = ev.clientY - startY;
      if (!axis) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (axis === 'x') {
          root.classList.add('is-dragging');
          try { viewport.setPointerCapture(ev.pointerId); } catch (e) {}
        }
      }
      if (axis !== 'x') return;
      var atEdge = (mx > 0 && i === 0) || (mx < 0 && i === slides.length - 1);
      dx = atEdge ? mx * 0.32 : mx;
      track.style.setProperty('--dx', dx + 'px');
    });
    function release(ev) {
      if (!down) return;
      down = false;
      if (axis !== 'x') { axis = ''; return; }
      root.classList.remove('is-dragging');
      try { viewport.releasePointerCapture(ev.pointerId); } catch (e) {}
      var w = viewport.getBoundingClientRect().width || 1;
      var v = Math.abs(dx) / Math.max(1, (ev.timeStamp - startT));
      var far = Math.abs(dx) > w * 0.18 || v > 0.45;
      if (far && dx < 0) go(i + 1);
      else if (far && dx > 0) go(i - 1);
      else { track.style.setProperty('--dx', '0px'); }
      dx = 0; axis = '';
    }
    viewport.addEventListener('pointerup', release);
    viewport.addEventListener('pointercancel', release);
    /* a drag that ends on a link must not also follow it */
    viewport.addEventListener('click', function (ev) {
      if (Math.abs(dx) > 4) { ev.preventDefault(); ev.stopPropagation(); }
    }, true);

    (reduce.addEventListener ? reduce.addEventListener.bind(reduce, 'change') : reduce.addListener.bind(reduce))(paint);
    paint();
  }

  function scan() { document.querySelectorAll('[data-obt-deck]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', function (ev) {
    var card = ev.target && ev.target.closest ? ev.target.closest('[data-deck-slide]') : null;
    if (!card) return;
    var deck = card.closest('[data-obt-deck]');
    if (!deck) return;
    var all = [].slice.call(deck.querySelectorAll('[data-deck-slide]'));
    var btn = deck.querySelector('[data-deck-go="' + all.indexOf(card) + '"]');
    if (btn) btn.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-positioning"] && !Shopify.designMode) return;
  try {
    
  /* obt-tilt-card — vanilla custom element.
     Adds a subtle pointer-driven 3D tilt to a glass card on top of the
     CSS hover lift. Writes --obt-tilt-x / --obt-tilt-y custom properties and
     a data-tilting flag; CSS owns the actual transform (GPU-only). Pauses
     off-screen via IntersectionObserver, honours reduced-motion + data-tilt
     opt-out, and resets cleanly on leave. NO Liquid. */
  if (!customElements.get('obt-tilt-card')) {
    class ObtTiltCard extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (this.dataset.tilt === 'off' || reduce || !finePointer) return;

        this.max = 5; /* deg */
        this.visible = true;
        this._onMove = this._onMove.bind(this);
        this._onLeave = this._onLeave.bind(this);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            if (!this.visible) this._onLeave();
          }, { rootMargin: '0px' });
          this.io.observe(this);
        }

        this.addEventListener('pointermove', this._onMove);
        this.addEventListener('pointerleave', this._onLeave);
      }

      disconnectedCallback() {
        this.removeEventListener('pointermove', this._onMove);
        this.removeEventListener('pointerleave', this._onLeave);
        if (this.io) this.io.disconnect();
      }

      _onMove(e) {
        if (!this.visible) return;
        const r = this.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        this.style.setProperty('--obt-tilt-y', (px * this.max).toFixed(2) + 'deg');
        this.style.setProperty('--obt-tilt-x', (-py * this.max).toFixed(2) + 'deg');
        this.setAttribute('data-tilting', '');
      }

      _onLeave() {
        this.removeAttribute('data-tilting');
        this.style.setProperty('--obt-tilt-x', '0deg');
        this.style.setProperty('--obt-tilt-y', '0deg');
      }
    }
    customElements.define('obt-tilt-card', ObtTiltCard);
  }

  /* Reveal arming — progressive enhancement, fail-safe.
     The reveal animation's hidden initial state (opacity:0 / clip) is gated in
     CSS on .obt-armed. Without JS the content is fully visible; here we arm the
     section so the CSS keyframe reveal can play, then set a safety timeout that
     force-reveals everything (.obt-revealed) if the animation ever stalls.
     Honours reduced-motion and data-obt-animate="off"/absent by NOT arming
     (so content simply stays visible). NO Liquid. */
  (function () {
    var armReveal = function (section) {
      if (!section || section._obtArmed) return;
      var anim = section.getAttribute('data-obt-animate');
      if (!anim || anim === 'none') return; /* static: leave visible */
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return; /* reduced motion: leave visible, never arm */
      }
      section._obtArmed = true;
      section.classList.add('obt-armed');
      /* Safety net: if the keyframe reveal never completes, force-show all. */
      section._obtSafety = window.setTimeout(function () {
        section.classList.add('obt-revealed');
      }, 1600);
      /* Once any reveal animation finishes, the safety net is unnecessary. */
      section.addEventListener('animationend', function onEnd() {
        window.clearTimeout(section._obtSafety);
        section.removeEventListener('animationend', onEnd);
      });
    };

    var armAll = function () {
      var sections = document.querySelectorAll('.obt-positioning[data-obt-animate]');
      for (var i = 0; i < sections.length; i++) armReveal(sections[i]);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', armAll);
    } else {
      armAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-principles"] && !Shopify.designMode) return;
  try {
    
/* Upgrades the static pillar list into a held stage.
   Contract: obt-motion.js writes --p (0..1) onto [data-obt-scroll="sticky"]
   against the DETECTED scroller, so this never touches window scroll itself.
   Arms only when there is room and motion is welcome; on anything else the
   markup stays the plain list it renders as. */
(function () {
  function boot(root) {
    if (!root || root.dataset.prinReady === '1') return;

    var items = [].slice.call(root.querySelectorAll('[data-prin-item]'));
    var rail = [].slice.call(root.querySelectorAll('.prin__rail-i'));
    var buttons = [].slice.call(root.querySelectorAll('[data-prin-go]'));
    if (items.length < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* HEIGHT, not width. A pinned stage needs a screen tall enough to hold one
       pillar; a portrait phone has that and a landscape phone does not, which is
       a question width cannot answer. Gating on (min-width: 900px) is what left
       the phone — the primary device for this audience — with a plain stacked
       list and no sequence at all. */
    var tall = window.matchMedia('(min-height: 560px)');
    var armed = false;
    var current = -1;

    /* Splits the pillar's name into per-character spans so it can be set
       letter by letter. Done once, at boot, and only for this heading — it is
       the largest thing on a screen the section owns outright, which is the
       only place a per-character treatment pays for itself.

       ⚠️ WORDS FIRST, THEN CHARACTERS. A heading split straight into
       characters gives the browser a soft-wrap opportunity between every pair
       of them, so „Прецизност" is free to break as „Прециз / ност" on a
       narrow screen. Each word is its own inline-block (see .prin__w), so the
       line can still only break where it could before.

       Array.from, not split(''): it iterates code points, so a name carrying
       anything outside the BMP does not come apart into surrogate halves.

       The accessible name is pinned with aria-label before the split, because
       a heading made of thirty spans is read as thirty fragments by some
       screen readers even though the text content is identical. */
    function splitTitle(h) {
      if (!h || h.dataset.prinSplit === '1') return;
      var text = (h.textContent || '').trim();
      if (!text) return;
      h.setAttribute('aria-label', text);
      var frag = document.createDocumentFragment();
      var parts = text.split(/(\s+)/);
      var ci = 0;
      for (var w = 0; w < parts.length; w++) {
        if (!parts[w]) continue;
        if (/^\s+$/.test(parts[w])) { frag.appendChild(document.createTextNode(parts[w])); continue; }
        var word = document.createElement('span');
        word.className = 'prin__w';
        word.setAttribute('aria-hidden', 'true');
        var chars = Array.from(parts[w]);
        for (var c = 0; c < chars.length; c++) {
          var ch = document.createElement('span');
          ch.className = 'prin__c';
          ch.style.setProperty('--ci', ci++);
          ch.textContent = chars[c];
          word.appendChild(ch);
        }
        frag.appendChild(word);
      }
      h.textContent = '';
      h.appendChild(frag);
      h.dataset.prinSplit = '1';
    }
    items.forEach(function (it) { splitTitle(it.querySelector('.prin__title')); });

    function paint(i) {
      if (i === current) return;
      current = i;
      /* the room takes the live pillar's colour — the ground wash reads this
         and cross-fades, so scrolling moves the whole stage red → dark green
         → green rather than only swapping the figure inside a fixed box */
      var pc = items[i] && items[i].style.getPropertyValue('--pc');
      if (pc) root.style.setProperty('--pc-live', pc.trim());
      for (var n = 0; n < items.length; n++) {
        items[n].classList.toggle('is-on', n === i);
        items[n].classList.toggle('is-past', n < i);
      }
      for (var r = 0; r < rail.length; r++) {
        rail[r].classList.toggle('is-on', r === i);
        rail[r].classList.toggle('is-past', r < i);
        if (buttons[r]) buttons[r].setAttribute('aria-current', r === i ? 'true' : 'false');
      }
    }

    /* Progress is measured off the section's own viewport rect — the same
       maths obt-motion uses for data-obt-scroll="sticky" — so it is correct
       whether the real scroller is the window or Horizon's .page-wrapper, and
       it costs one rect read per frame instead of a computed-style lookup per
       scroll event. rAF-throttled: the raw scroll event fires far faster than
       the screen can show a change. */
    var ticking = false;
    function tick() {
      if (ticking || !armed) return;
      ticking = true;
      requestAnimationFrame(measure);
    }
    function measure() {
      ticking = false;
      if (!armed) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = root.getBoundingClientRect();
      var travel = r.height - vh;
      var p = travel <= 0 ? 0 : -r.top / travel;
      if (p < 0) p = 0; else if (p > 1) p = 1;
      var scaled = p * items.length;
      var i = Math.floor(scaled);
      if (i > items.length - 1) i = items.length - 1;
      if (i < 0) i = 0;
      /* ⚠️ THE SUB-STEP IS WHY THIS SECTION NO LONGER FEELS DEAD.
         Three pillars across 776px of pin means 259px of scrolling in which
         nothing at all used to change — most of a swipe on a phone, which is
         exactly what Mr. Markov reported on 2026-08-13 as "I scroll here, I
         don't see anything". The live pillar's own progress is now written out
         every frame and the rail's active bar fills with it, so the section
         responds to every pixel even between swaps. One custom property, no
         extra layout reads: `r` is already measured above. */
      var sub = scaled - i;
      if (sub < 0) sub = 0; else if (sub > 1) sub = 1;
      if (p >= 1) sub = 1;
      root.style.setProperty('--prin-sub', sub.toFixed(3));
      root.style.setProperty('--prin-p', p.toFixed(3));
      paint(i);
    }

    function arm() {
      var want = tall.matches && !reduce.matches;
      if (want === armed) return;
      armed = want;
      root.classList.toggle('is-stage', armed);
      if (armed) { current = -1; measure(); }
      else {
        root.classList.remove('is-stage');
        for (var n = 0; n < items.length; n++) items[n].classList.remove('is-on', 'is-past');
        for (var r = 0; r < rail.length; r++) rail[r].classList.remove('is-on');
        current = -1;
      }
    }

    buttons.forEach(function (b) {
      b.removeAttribute('tabindex');
      b.addEventListener('click', function () {
        if (!armed) return;
        var idx = parseInt(b.getAttribute('data-prin-go'), 10) || 0;
        var sc = (window.obtScroller && window.obtScroller()) || document.scrollingElement;
        var top = root.getBoundingClientRect().top + (sc === document.scrollingElement ? (window.pageYOffset || 0) : sc.scrollTop);
        var travel = root.offsetHeight - (window.innerHeight || 0);
        var want = top + travel * ((idx + 0.5) / items.length);
        sc.scrollTo({ top: want, behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    });

    (tall.addEventListener ? tall.addEventListener.bind(tall, 'change') : tall.addListener.bind(tall))(arm);
    (reduce.addEventListener ? reduce.addEventListener.bind(reduce, 'change') : reduce.addListener.bind(reduce))(arm);

    arm();
    if (window.obtOnScroll) window.obtOnScroll(tick);
    window.addEventListener('resize', tick, { passive: true });
    root.dataset.prinReady = '1';
  }

  function scan() {
    document.querySelectorAll('[data-obt-prin]').forEach(boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-product-timeline"] && !Shopify.designMode) return;
  try {
    
/* Milestone activation. Pure IntersectionObserver: on desktop Horizon scrolls
   .page-wrapper, not the window, so anything reading scrollY would be wrong.
   Once a milestone lights up it stays lit, because the point is that the work
   accumulates. Multi instance and editor reload safe. */
(function () {
  function setup(root) {
    if (root.getAttribute('data-ptl-init')) return;
    root.setAttribute('data-ptl-init', '1');

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-obt-step]'));
    var rail = root.querySelector('[data-obt-rail]');
    if (!steps.length || !rail) return;

    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function lightAll() {
      steps.forEach(function (s) { s.classList.add('is-on'); });
      rail.style.setProperty('--ptl-fill', '100%');
    }
    root.classList.add('is-js');
    if (reduce || !('IntersectionObserver' in window)) { lightAll(); return; }

    var highest = -1;
    function paintFill() {
      if (highest < 0) return;
      var horizontal = window.innerWidth >= 1100;
      var box = rail.getBoundingClientRect();
      var mark = (steps[highest].querySelector('.obt-ptl__dot') || steps[highest]).getBoundingClientRect();
      var pct = horizontal
        ? ((mark.left + mark.width / 2) - box.left) / box.width * 100
        : ((mark.top + mark.height / 2) - box.top) / box.height * 100;
      rail.style.setProperty('--ptl-fill', Math.max(0, Math.min(100, pct)) + '%');
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = steps.indexOf(e.target);
        e.target.classList.add('is-on');
        if (i > highest) highest = i;
      });
      paintFill();
    }, { rootMargin: '0px 0px -30% 0px', threshold: 0.01 });
    steps.forEach(function (s) { io.observe(s); });

    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(paintFill, 140); }, { passive: true });
    /* failsafe: never leave the band dimmed if the observer never fires */
    window.setTimeout(function () { if (highest < 0) lightAll(); }, 4000);
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-obt-ptl]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-product"] && !Shopify.designMode) return;
  try {
    
/* obt-product-gallery — focused stage, accessible tabs, optional zoom. */
if (!customElements.get('obt-product-gallery')) {
  class ObtProductGallery extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-obt-zoom]'));
      this.buttons.forEach((b, i) => b.addEventListener('click', () => this.openZoom(i)));
      this.slides = Array.from(this.querySelectorAll('[data-obt-slide]'));
      this.tabs = Array.from(this.querySelectorAll('[data-obt-tab]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(Number(tab.dataset.obtTab)));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var at = this.tabs.indexOf(tab);
          var next = (at + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.tabs[next].focus();
          this.select(Number(this.tabs[next].dataset.obtTab));
        });
      });
    }
    select(index) {
      this.slides.forEach(function (slide) {
        var on = Number(slide.dataset.obtSlide) === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      this.tabs.forEach(function (tab) {
        var on = Number(tab.dataset.obtTab) === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
    }
    /** variant switching still points the cover at the variant image */
    setImage(url) {
      var lead = this.querySelector('.obt-pg__img--cover');
      if (lead && url) { lead.removeAttribute('srcset'); lead.src = url; }
      var btn = this.querySelector('.obt-pg__image-btn--cover');
      if (btn && url) btn.setAttribute('data-full', url);
    }
    openZoom(index) {
      var self = this;
      var i = index || 0;
      var box = document.createElement('div');
      box.className = 'obt-product__lightbox';
      var img = document.createElement('img');
      function paint() {
        var btn = self.buttons[i];
        if (!btn) return;
        var thumb = btn.querySelector('img');
        img.src = btn.getAttribute('data-full') || (thumb && (thumb.currentSrc || thumb.src)) || '';
        img.alt = (thumb && thumb.alt) || '';
      }
      paint();
      box.appendChild(img);
      document.body.appendChild(box);
      requestAnimationFrame(() => box.classList.add('is-open'));
      var close = () => { box.remove(); document.removeEventListener('keydown', onKey); };
      var onKey = (e) => {
        if (e.key === 'Escape') return close();
        if (e.key === 'ArrowRight') { i = (i + 1) % self.buttons.length; paint(); }
        if (e.key === 'ArrowLeft') { i = (i - 1 + self.buttons.length) % self.buttons.length; paint(); }
      };
      box.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
    }
  }
  customElements.define('obt-product-gallery', ObtProductGallery);
}

/* Sticky mobile mirror: click delegates to the real product form. Visibility is
   intersection-driven, so two buy buttons never compete on screen. */
(function () {
  function wire(root) {
    if (root.dataset.obtStickyInit === '1') return;
    root.dataset.obtStickyInit = '1';
    var sticky = root.querySelector('[data-obt-sticky]');
    var real = root.querySelector('.obt-product__add');
    var price = root.querySelector('[data-obt-price-now]');
    var stickyPrice = root.querySelector('[data-obt-sticky-price]');
    if (!sticky || !real) return;
    sticky.hidden = false;
    sticky.querySelector('[data-obt-sticky-add]').addEventListener('click', function () { real.click(); });
    if (price && stickyPrice) {
      var sync = function () { stickyPrice.textContent = price.textContent; };
      sync();
      new MutationObserver(sync).observe(price, { childList:true, subtree:true, characterData:true });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
      }, { threshold:.1 }).observe(real);
    }
  }
  function boot() { document.querySelectorAll('.obt-product').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Sticky rail. A column taller than the viewport cannot pin from the top or
   its own bottom becomes unreachable, so in that case it pins from the bottom
   instead via a negative top offset. Recomputed whenever a panel opens or the
   window resizes, since both change the rail's height. */
(function () {
  var HEAD = 76;   /* clearance for the floating header */
  var TAIL = 20;   /* breathing room under the rail when it pins from the bottom */
  function measure() {
    document.querySelectorAll('[data-obt-side]').forEach(function (side) {
      if (window.innerWidth < 990) { side.classList.remove('is-sticky'); side.style.removeProperty('--obt-side-top'); return; }
      var h = side.offsetHeight;
      var vh = window.innerHeight;
      var top = (h + HEAD + TAIL <= vh) ? HEAD : (vh - h - TAIL);
      side.style.setProperty('--obt-side-top', Math.round(top) + 'px');
      side.classList.add('is-sticky');
    });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(measure, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure);
  else measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', schedule);
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
})();

/* obt-product-buy — variant option -> matching variant: updates hidden id (form POST honours it),
   price, availability + best-effort gallery image. Self-contained; no Horizon variant-picker needed. */
if (!customElements.get('obt-product-buy')) {
  class ObtProductBuy extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-obt-variants]');
      try { this.variants = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { this.variants = []; }
      this.idInput = this.querySelector('[data-obt-variant-id]');
      this.inputs = Array.from(this.querySelectorAll('[data-obt-option-input]'));
      this.priceNow = this.querySelector('[data-obt-price-now]');
      this.priceWas = this.querySelector('[data-obt-price-was]');
      this.priceWrap = this.querySelector('[data-obt-price]');
      this.saveEl = this.querySelector('[data-obt-save]');
      this.addBtn = this.querySelector('.obt-product__add');
      this.gallery = document.querySelector('obt-product-gallery');
      if (this.inputs.length) this.inputs.forEach((i) => i.addEventListener('change', () => this.onChange()));
    }
    selectedOptions() {
      var byIndex = {};
      this.inputs.forEach((i) => { if (i.checked) { var m = i.name.match(/obt-option-(\d+)/); if (m) byIndex[+m[1]] = i.value; } });
      return byIndex;
    }
    money(cents) {
      // fall back to the theme's format via existing DOM string when possible
      try { return (cents / 100).toLocaleString('bg-BG', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BGN' }); }
      catch (e) { return (cents / 100).toFixed(2); }
    }
    onChange() {
      if (!this.variants.length) return;
      var sel = this.selectedOptions();
      var match = this.variants.find((v) => {
        var opts = v.options || [];
        return Object.keys(sel).every((k) => String(opts[+k]) === String(sel[+k]));
      });
      if (!match) return;
      if (this.idInput) this.idInput.value = match.id;
      if (this.priceNow) this.priceNow.textContent = this.money(match.price);
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      if (this.priceWrap) this.priceWrap.classList.toggle('is-sale', !!onSale);
      if (this.priceWas) this.priceWas.style.display = onSale ? '' : 'none';
      if (this.priceWas && onSale) this.priceWas.textContent = this.money(match.compare_at_price);
      if (this.saveEl) {
        if (onSale) { this.saveEl.style.display = ''; this.saveEl.textContent = '-' + Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100) + '%'; }
        else this.saveEl.style.display = 'none';
      }
      if (this.addBtn) {
        this.addBtn.disabled = !match.available;
        var txtEl = this.addBtn.querySelector('.add-to-cart-text__content span span');
        if (txtEl) txtEl.textContent = match.available ? (this.getAttribute('data-add-text') || txtEl.textContent) : 'Изчерпан';
      }
      // best-effort image swap
      if (this.gallery && match.featured_image && match.featured_image.src) {
        this.gallery.setImage(match.featured_image.src);
      }
      // keep the URL variant param in sync (product-form reads it)
      try { var u = new URL(window.location.href); u.searchParams.set('variant', match.id); window.history.replaceState({}, '', u); } catch (e) {}
    }
  }
  customElements.define('obt-product-buy', ObtProductBuy);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-products"] && !Shopify.designMode) return;
  try {
    
  /* obt-product-grid — vanilla custom element.
     1. Assigns each card a --obt-i index + --obt-stagger so the CSS reveal
        cascades like the source's staggered card entrance.
     2. If the section opts into scroll-triggering, an IntersectionObserver
        adds .is-in to the section once the grid scrolls into view (one-shot),
        which arms the CSS animations. Off-screen until then -> no wasted work.
     Reduced-motion aware, GPU-only (transform/opacity), no layout animation,
     no CLS, guarded with customElements.get. NO Liquid. */
  if (!customElements.get('obt-product-grid')) {
    class ObtProductGrid extends HTMLElement {
      connectedCallback() {
        var step = parseFloat(this.dataset.stagger || '90');
        var cards = Array.from(this.querySelectorAll('[data-obt-card]'));
        cards.forEach(function (card, i) {
          card.style.setProperty('--obt-i', String(i));
          card.style.setProperty('--obt-stagger', step + 'ms');
        });

        var section = this.closest('.obt-products');
        if (!section) return;

        var animated = section.hasAttribute('data-obt-animate');
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var scrollTrigger = section.hasAttribute('data-obt-on-scroll');

        // Not animated, reduced motion, or no IO support: leave content visible.
        // Do NOT arm — content must show with no further work.
        if (!animated || !scrollTrigger || reduce || !('IntersectionObserver' in window)) {
          this._showAll(section);
          return;
        }

        // Animated path: arm the element so CSS hides items, then reveal.
        section.classList.add('obt-armed');

        var self = this;
        this.io = new IntersectionObserver(function (entries, obs) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              self._showAll(section);
              obs.disconnect();
              break;
            }
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
        this.io.observe(this);

        // Safety net: if the observer never fires (theme editor, odd loads),
        // force-reveal everything so the section can never stay blank.
        this.safety = setTimeout(function () { self._showAll(section); }, 1600);
      }

      _showAll(section) {
        section = section || this.closest('.obt-products');
        if (section) section.classList.add('is-in');
        if (this.safety) { clearTimeout(this.safety); this.safety = null; }
        if (this.io) { this.io.disconnect(); this.io = null; }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.safety) clearTimeout(this.safety);
      }
    }
    customElements.define('obt-product-grid', ObtProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-proof-counters"] && !Shopify.designMode) return;
  try {
    
  /* Shared, window-guarded lazy GSAP loader — loads GSAP core + requested
     plugins ONCE per page, after first paint, never blocking LCP. Idempotent:
     multiple ONEBAR sections can call it safely; the bundled javascript tag
     defines it once globally. NO Liquid. */
  window.obtLoadGsap = window.obtLoadGsap || function(plugins){
    window.__obtGsapP = window.__obtGsapP || new Promise(function(res){
      var core = document.createElement("script");
      core.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js";
      core.onload = function(){ res(); };
      document.head.appendChild(core);
    });
    return window.__obtGsapP.then(function(){
      var jobs = (plugins||[]).map(function(p){
        if (window[p]) return Promise.resolve();
        window["__obtP_"+p] = window["__obtP_"+p] || new Promise(function(r){
          var s=document.createElement("script");
          s.src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/"+p+".min.js";
          s.onload=function(){ r(); }; document.head.appendChild(s);
        });
        return window["__obtP_"+p];
      });
      return Promise.all(jobs).then(function(){
        if (plugins) plugins.forEach(function(p){ if (window.gsap && window[p]) window.gsap.registerPlugin(window[p]); });
        return window.gsap;
      });
    });
  };

  /* obt-proof-arm — FAIL-SAFE reveal arming for the proof-counters cards.
     The card reveal animation lives in CSS but is gated by the .obt-armed
     class so content is ALWAYS visible without JS. This routine arms each
     animated section, then sets a safety timeout that force-reveals every
     card if the CSS animation never completes (editor/preview/interrupted),
     guaranteeing the section is NEVER blank. Reduced-motion and
     data-obt-animate absent are left untouched (already visible). NO Liquid. */
  if (!window.__obtProofArmed) {
    window.__obtProofArmed = true;
    var obtArmProof = function(section){
      if (!section || section.__obtArmed) return;
      // Respect reduced-motion: never arm, leave cards visible.
      if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
      if (!section.getAttribute('data-obt-animate')) return;
      section.__obtArmed = true;
      // Arm: now the CSS hidden initial states + reveal animations apply.
      section.classList.add('obt-armed');
      var showAll = function(){
        section.classList.add('obt-reveal-all');
        var cards = section.querySelectorAll('.obt-proof-counters__card');
        for (var i = 0; i < cards.length; i++) cards[i].classList.add('is-visible');
      };
      // Safety net: if the CSS animation never finishes (e.g. throttled in the
      // theme editor / preview), force everything visible after a short delay.
      section.__obtSafety = setTimeout(showAll, 1600);
      // Clear the safety timer once any card animation completes naturally.
      section.addEventListener('animationend', function(){
        if (section.__obtSafety) { clearTimeout(section.__obtSafety); section.__obtSafety = null; }
      }, { once: true });
    };
    var obtArmAll = function(root){
      var nodes = (root || document).querySelectorAll('.obt-proof-counters[data-obt-animate]');
      for (var i = 0; i < nodes.length; i++) obtArmProof(nodes[i]);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ obtArmAll(); });
    } else {
      obtArmAll();
    }
    // Re-arm sections added/updated in the theme editor.
    document.addEventListener('shopify:section:load', function(e){ obtArmAll(e.target); });
  }

  /* obt-count-up — custom element with GSAP-hybrid count-up.
     If data-count-to is present and motion is allowed, lazy-loads GSAP +
     ScrollTrigger when the element scrolls into view and tweens the displayed
     number from 0 to the target, then locks to the merchant's literal display
     value (data-value). Without data-count-to (count-up off, or non-numeric
     placeholder like an em dash) it stays fully static. Under reduced-motion
     GSAP is NEVER loaded — the literal value is shown immediately.
     customElements guard + IntersectionObserver (in-view gate) retained.
     NO Liquid. */
  if (!customElements.get('obt-count-up')) {
    class ObtCountUp extends HTMLElement {
      connectedCallback() {
        const target = parseFloat(this.dataset.countTo || '');
        // No count-to => nothing to animate; the literal default stays.
        if (!isFinite(target)) return;

        // Reduced-motion: show final value immediately, never load GSAP.
        const allowMotion = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
        if (!allowMotion) return;

        this.target = target;
        this.prefix = this.dataset.prefix || '';
        this.suffix = this.dataset.suffix || '';
        this.finalText = this.textContent;
        // Preserve decimal precision from the target string.
        const raw = (this.dataset.countTo || '').trim();
        const dot = raw.indexOf('.');
        this.decimals = dot === -1 ? 0 : (raw.length - dot - 1);

        const section = this.closest('[data-obt-on-scroll]');
        const durMs = parseFloat(
          (section && getComputedStyle(section).getPropertyValue('--obt-count-duration')) || '1600'
        ) || 1600;
        this.duration = durMs / 1000;

        this.done = false;

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !this.done) {
              this.done = true;
              if (this.io) this.io.disconnect();
              this._run();
            }
          }, { rootMargin: '0px 0px -10% 0px' });
          this.io.observe(this);
        } else {
          // No IO support: leave the literal value in place.
          this.textContent = this.finalText;
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this._st && this._st.kill) this._st.kill();
      }

      _format(n) {
        return this.prefix + n.toFixed(this.decimals) + this.suffix;
      }

      _run() {
        const el = this;
        // In view + motion allowed => lazy-load GSAP core + ScrollTrigger.
        window.obtLoadGsap(['ScrollTrigger']).then(function(gsap){
          if (!gsap) { el.textContent = el.finalText; return; }
          const counter = { val: 0 };
          gsap.to(counter, {
            val: el.target,
            duration: el.duration,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: el,
              start: 'top bottom-=10%',
              once: true
            },
            onUpdate: function(){
              el.textContent = el._format(counter.val);
            },
            onComplete: function(){
              // Snap to the merchant's exact display string at the end.
              el.textContent = el.finalText;
            }
          });
        }).catch(function(){
          // CDN failed => show final value, never leave it at 0.
          el.textContent = el.finalText;
        });
      }
    }
    customElements.define('obt-count-up', ObtCountUp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-refuse-grid"] && !Shopify.designMode) return;
  try {
    
  /* obt-refuse-grid — vanilla custom element.
     Optional scroll-triggered reveal: when the section opts in
     (data-obt-scroll="on"), add [data-obt-inview] the first time the band
     enters the viewport so the CSS reveal fires on scroll instead of on load.
     IntersectionObserver, one-shot, reduced-motion aware. NO Liquid. */
  if (!customElements.get('obt-refuse-grid')) {
    class ObtRefuseGrid extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.obt-refuse-grid');
        if (!this.section) return;

        const scrollGated = this.section.dataset.obtScroll === 'on';
        const animated = this.section.hasAttribute('data-obt-animate');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // No scroll gating, reduced motion, or no animation → reveal immediately.
        // (Never arm in these cases: content must stay visible.)
        if (!scrollGated || !animated || reduce || !('IntersectionObserver' in window)) {
          this.section.setAttribute('data-obt-inview', '');
          return;
        }

        // Animated path: arm the hidden resting state only now that JS is live
        // and able to reveal it again. If anything below is interrupted, the
        // safety timeout still force-reveals everything.
        this.section.classList.add('obt-armed');

        this.io = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this._reveal();
              break;
            }
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
        this.io.observe(this.section);

        // Fail-safe: if the observer never fires (editor, odd loads), reveal.
        this.safety = window.setTimeout(() => this._reveal(), 1600);
      }

      _reveal() {
        this.section.setAttribute('data-obt-inview', '');
        if (this.io) {
          this.io.disconnect();
          this.io = null;
        }
        if (this.safety) {
          window.clearTimeout(this.safety);
          this.safety = null;
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.safety) window.clearTimeout(this.safety);
      }
    }
    customElements.define('obt-refuse-grid', ObtRefuseGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-refuse"] && !Shopify.designMode) return;
  try {
    
  /* Premium reveal for the Refuse band. GSAP-optional; IntersectionObserver-driven
     with a failsafe so content is never stuck hidden. Reduced-motion → static. */
  (function () {
    function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }

    function setup(sec) {
      if (sec.dataset.obtRefuseInit) return;
      sec.dataset.obtRefuseInit = '1';

      var g = window.gsap;
      var rises = Array.prototype.slice.call(sec.querySelectorAll('.obt-refuse__rise'));
      var rows = Array.prototype.slice.call(sec.querySelectorAll('.obt-refuse__row'));
      if (!g || reduced() || !('IntersectionObserver' in window)) return; // stays fully visible

      sec.classList.add('is-armed');
      g.set(rises, { autoAlpha: 0, y: 22 });
      g.set(rows, { autoAlpha: 0, x: -20 });
      var rules = sec.querySelectorAll('.obt-refuse__rule');
      g.set(rules, { scaleX: 0 });

      // prime each X mark to draw itself
      var strokes = [];
      rows.forEach(function (it) {
        it.querySelectorAll('.obt-refuse__x-a, .obt-refuse__x-b').forEach(function (p) {
          var len = 26;
          try { len = p.getTotalLength() || 26; } catch (e) {}
          g.set(p, { strokeDasharray: len, strokeDashoffset: len });
          strokes.push(p);
        });
      });

      var played = false;
      function play() {
        if (played) return;
        played = true;
        var tl = g.timeline({ defaults: { ease: 'expo.out' } });
        tl.to(rises, { autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.1 });
        tl.to(rows, { autoAlpha: 1, x: 0, duration: 0.6, stagger: 0.07 }, '-=0.35');
        tl.to(strokes, { strokeDashoffset: 0, duration: 0.4, ease: 'power2.out', stagger: 0.03 }, '<0.05');
        tl.to(rules, { scaleX: 1, duration: 0.55, ease: 'power3.out', stagger: 0.07 }, '<0.05');
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(); io.disconnect(); } });
      }, { threshold: 0.16 });
      io.observe(sec);
      setTimeout(function () { play(); try { io.disconnect(); } catch (e) {} }, 2800);
    }

    function boot() { document.querySelectorAll('[data-obt-refuse]').forEach(setup); }
    if (document.readyState === 'complete') boot(); else window.addEventListener('load', boot);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-obt-refuse]').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-results-discipline"] && !Shopify.designMode) return;
  try {
    
  /* obt-tag-stagger — vanilla custom element.
     Assigns each child pill a --obt-i index (for stagger ordering) and flips
     data-inview="true" once the group scrolls into view, which the CSS uses
     to launch the staggered pop-in. IntersectionObserver-driven, runs once,
     reduced-motion aware, NO Liquid. Static (visible) fallback when motion
     is off or the API is unavailable. */
  if (!customElements.get('obt-tag-stagger')) {
    class ObtTagStagger extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tags = Array.from(this.children).filter(function (el) {
          return el.classList && el.classList.contains('obt-results-discipline__tag');
        });
        this.tags.forEach(function (el, i) {
          el.style.setProperty('--obt-i', i);
        });

        if (this.dataset.stagger === 'off' || reduce || !('IntersectionObserver' in window)) {
          /* Show-all path: leave pills fully visible. Do NOT arm. */
          this.setAttribute('data-inview', 'true');
          return;
        }

        /* Animated path: arm now (CSS hides the pills) so we own the reveal.
           Until this line runs, the pills stay visible — never blank. */
        this.classList.add('obt-armed');

        var self = this;
        this.io = new IntersectionObserver(function (entries, obs) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) {
              self._reveal();
              obs.disconnect();
              break;
            }
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 });
        this.io.observe(this);

        /* Safety net: if the observer never fires (theme editor, odd
           storefront loads), force-reveal so the pills can't stay hidden. */
        this.safety = setTimeout(function () { self._reveal(); }, 1600);
      }

      _reveal() {
        if (this.safety) { clearTimeout(this.safety); this.safety = null; }
        this.setAttribute('data-inview', 'true');
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.safety) { clearTimeout(this.safety); this.safety = null; }
      }
    }
    customElements.define('obt-tag-stagger', ObtTagStagger);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-results-fan"] && !Shopify.designMode) return;
  try {
    
  /* obt-fan — GSAP-hybrid draggable card-fan custom element.
     The hand-rolled Pointer-event drag is replaced by GSAP Draggable (type "x"),
     matching the original horizontal drag model. CSS fan transforms / per-card
     layout are untouched — _layout() still writes the same --obt-* vars.

     GSAP loading contract (shared, idempotent, lazy):
       • GSAP + Draggable load ONCE per page via window.obtLoadGsap.
       • Loaded ONLY when (a) the element is in view (IntersectionObserver) AND
         (b) prefers-reduced-motion: no-preference. Reduced motion never loads
         GSAP — the static flow/grid fallback is left exactly as is.

     Behaviour:
       • On >=750px with motion allowed, lays the cards out as a fan: each card
         gets rotation/translate based on its offset from the active index.
       • A hidden proxy is dragged on the x-axis via Draggable; the proxy's x is
         mapped to a fractional card offset that drives _layout() live.
       • Draggable `snap` rounds to the nearest card on release; onDragEnd runs a
         smooth eased gsap.to settle into the chosen card.
       • Prev/next buttons and ArrowLeft/ArrowRight step the active card.
       • Reduced-motion or data-static="grid" => stays a plain flow/grid, no GSAP
         load, drag disabled. Config via data-*, NO Liquid. */

  window.obtLoadGsap = window.obtLoadGsap || function(plugins){
    window.__obtGsapP = window.__obtGsapP || new Promise(function(res){
      var core = document.createElement("script");
      core.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js";
      core.onload = function(){ res(); };
      document.head.appendChild(core);
    });
    return window.__obtGsapP.then(function(){
      var jobs = (plugins||[]).map(function(p){
        if (window[p]) return Promise.resolve();
        window["__obtP_"+p] = window["__obtP_"+p] || new Promise(function(r){
          var s=document.createElement("script");
          s.src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/"+p+".min.js";
          s.onload=function(){ r(); }; document.head.appendChild(s);
        });
        return window["__obtP_"+p];
      });
      return Promise.all(jobs).then(function(){
        if (plugins) plugins.forEach(function(p){ if (window.gsap && window[p]) window.gsap.registerPlugin(window[p]); });
        return window.gsap;
      });
    });
  };

  if (!customElements.get('obt-fan')) {
    class ObtFan extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.obt-results-fan__card'));
        if (!this.cards.length) return;

        this.reduce = !window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
        this.isGrid = this.dataset.static === 'grid';
        this.snap = this.dataset.snap !== 'false';
        this.mq = window.matchMedia('(min-width: 750px)');

        this.active = Math.floor(this.cards.length / 2);
        this.dragUnit = 240;     // px of drag per one card step (Draggable proxy)
        this.gsap = null;        // set once GSAP resolves
        this.draggable = null;   // Draggable instance
        this.proxy = null;       // hidden element Draggable acts on

        // Bind handlers
        this._onKey = this._onKey.bind(this);
        this._onMqChange = this._onMqChange.bind(this);

        // Controls (siblings inside the same section)
        this.section = this.closest('.obt-results-fan');
        if (this.section) {
          this.prevBtn = this.section.querySelector('[data-obt-fan-prev]');
          this.nextBtn = this.section.querySelector('[data-obt-fan-next]');
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
        }

        this.addEventListener('keydown', this._onKey);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this._onMqChange);

        // Lay out the static fan immediately (no JS gating of content).
        this._apply();

        // ── Header reveal: FAIL-SAFE arming ──
        // Reduced motion (or animation="none") leaves the header fully visible:
        // do NOT arm — the .obt-armed hidden state never engages.
        const animated = !this.reduce && this.section &&
          this.section.hasAttribute('data-obt-animate');
        if (animated) {
          // Arm: now the CSS sets opacity:0/clip and the keyframe reveals it.
          this.section.classList.add('obt-armed');
          // SAFETY: if the CSS animation is ever interrupted/cancelled (editor,
          // tab switch, display toggling), force the header back to visible.
          this._revealTimer = setTimeout(() => this._showHeader(), 1600);
        }

        // Lazy-load GSAP only when in view AND motion is allowed.
        if (!this.reduce && 'IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                this._io.disconnect();
                this._io = null;
                this._initGsap();
                break;
              }
            }
          }, { rootMargin: '200px' });
          this._io.observe(this);
        }
      }

      // Force the header fully visible regardless of animation state. Clearing
      // the animation/clip lets the un-armed (visible) base styles win.
      _showHeader() {
        if (!this.section) return;
        const items = this.section.querySelectorAll('.obt-results-fan__head > *');
        for (const el of items) {
          el.style.opacity = '1';
          el.style.transform = 'none';
          el.style.clipPath = 'none';
          el.style.animation = 'none';
        }
      }

      disconnectedCallback() {
        if (this._io) { this._io.disconnect(); this._io = null; }
        if (this._revealTimer) { clearTimeout(this._revealTimer); this._revealTimer = null; }
        if (this.draggable) { this.draggable.kill(); this.draggable = null; }
        if (this.proxy && this.proxy.parentNode) this.proxy.parentNode.removeChild(this.proxy);
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this._onMqChange);
      }

      get fanActive() {
        return !this.isGrid && !this.reduce && this.mq.matches;
      }

      _onMqChange() {
        this._apply();
        if (this.draggable) this.draggable.enabled(this.fanActive);
      }

      _apply() {
        if (!this.fanActive) {
          // Static flow / grid — strip fan styling
          this.removeAttribute('data-mode');
          for (const c of this.cards) c.removeAttribute('style');
          return;
        }
        this.setAttribute('data-mode', 'fan');
        this._layout(0);
      }

      _initGsap() {
        if (this.gsap || this.isGrid) return;
        window.obtLoadGsap(['Draggable']).then((gsap) => {
          this.gsap = gsap;
          this._setupDraggable();
        });
      }

      _setupDraggable() {
        if (!this.gsap || !window.Draggable || this.draggable) return;

        // Hidden proxy element Draggable manipulates (type "x").
        const proxy = document.createElement('div');
        proxy.style.position = 'absolute';
        proxy.style.width = '1px';
        proxy.style.height = '1px';
        proxy.style.pointerEvents = 'none';
        proxy.style.visibility = 'hidden';
        this.appendChild(proxy);
        this.proxy = proxy;

        const self = this;
        const unit = this.dragUnit;

        this.draggable = window.Draggable.create(proxy, {
          trigger: this,
          type: 'x',
          allowEventDefault: true,
          dragClickables: false,
          // Snap proxy.x to whole-card steps from the active index.
          snap: this.snap ? function(value) {
            const minX = -(self.cards.length - 1 - self.active) * unit;
            const maxX = self.active * unit;
            const clamped = Math.max(minX, Math.min(maxX, value));
            return Math.round(clamped / unit) * unit;
          } : false,
          onPressInit: function() {
            // Reset proxy so each drag is relative to the current active card.
            self.gsap.set(proxy, { x: 0 });
            this.update();
          },
          onDragStart: function() {
            self.classList.add('is-dragging');
          },
          onDrag: function() {
            // Drag left (negative x) advances forward through the deck.
            const frac = -this.x / unit;
            const clamped = Math.max(-0.6, Math.min(self.cards.length - 1 - self.active + 0.6, frac));
            self._layout(clamped);
          },
          onDragEnd: function() {
            self.classList.remove('is-dragging');
            // this.endX is the snapped resting x (or raw x when snap is off).
            const target = self.snap
              ? Math.round(-this.endX / unit)
              : Math.round(-this.x / unit);
            const nextActive = Math.max(0, Math.min(self.cards.length - 1, self.active + target));
            const delta = nextActive - self.active;
            self.active = nextActive;
            self.gsap.set(proxy, { x: 0 });

            // Smooth eased settle from where the drag left off into the card.
            const fromFrac = -this.x / unit - delta;
            const dur = (parseFloat(getComputedStyle(self).getPropertyValue('--obt-anim-duration')) || 520) / 1000;
            const obj = { f: fromFrac };
            self.gsap.to(obj, {
              f: 0,
              duration: dur,
              ease: 'power3.out',
              onUpdate: function() { self._layout(obj.f); },
              onComplete: function() { self._layout(0); }
            });
          }
        })[0];

        this.draggable.enabled(this.fanActive);
        this._layout(0);
      }

      _layout(dragFrac) {
        const spread = parseFloat(getComputedStyle(this).getPropertyValue('--obt-fan-spread')) || 90;
        const rotStep = parseFloat(getComputedStyle(this).getPropertyValue('--obt-fan-rotate')) || 7;
        const n = this.cards.length;
        const center = this.active + (dragFrac || 0);
        for (let i = 0; i < n; i++) {
          const off = i - center;               // signed distance from active
          const abs = Math.abs(off);
          const x = off * spread;               // horizontal fan-out
          const y = abs * abs * 14;             // arc downward at the edges
          const rot = off * rotStep;            // rotation per step
          const scale = Math.max(0.82, 1 - abs * 0.06);
          const op = abs > 3.4 ? 0 : Math.max(0.18, 1 - abs * 0.16);
          const bright = Math.max(0.55, 1 - abs * 0.14);
          const z = Math.round(100 - abs * 10);
          const s = this.cards[i].style;
          s.setProperty('--obt-x', x.toFixed(2) + 'px');
          s.setProperty('--obt-y', y.toFixed(2) + 'px');
          s.setProperty('--obt-rot', rot.toFixed(2) + 'deg');
          s.setProperty('--obt-scale', scale.toFixed(3));
          s.setProperty('--obt-op', op.toFixed(2));
          s.setProperty('--obt-bright', bright.toFixed(2));
          s.setProperty('--obt-z', z);
        }
      }

      step(dir) {
        if (!this.fanActive) return;
        this.active = Math.max(0, Math.min(this.cards.length - 1, this.active + dir));
        // Eased settle when GSAP is present; otherwise CSS transition handles it.
        if (this.gsap) {
          const dur = (parseFloat(getComputedStyle(this).getPropertyValue('--obt-anim-duration')) || 520) / 1000;
          const obj = { f: -dir };
          const self = this;
          this.gsap.to(obj, {
            f: 0,
            duration: dur,
            ease: 'power3.out',
            overwrite: true,
            onUpdate: function() { self._layout(obj.f); },
            onComplete: function() { self._layout(0); }
          });
        } else {
          this._layout(0);
        }
      }

      _onKey(e) {
        if (!this.fanActive) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
      }
    }
    customElements.define('obt-fan', ObtFan);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-reward-band"] && !Shopify.designMode) return;
  try {
    
  /* obt-reward-band — vanilla custom element.
     Subtle scroll parallax on the full-bleed background image: as the band
     scrolls through the viewport the image translates vertically by up to
     parallaxCap px (the image is pre-scaled 1.08 so no edge is exposed).
     rAF-throttled, passive listener, IntersectionObserver-paused off-screen,
     reduced-motion aware, GPU-only transform. NO Liquid. */
  if (!customElements.get('obt-reward-band')) {
    class ObtRewardBand extends HTMLElement {
      connectedCallback() {
        this.cap = parseFloat(this.dataset.parallaxCap || '60');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        /* The reveal CSS lives on the parent <section.obt-reward-band>, not on
           this background element. Resolve it so we can arm + force-reveal. */
        this.section = this.closest('section.obt-reward-band');
        this._showAll = this._showAll.bind(this);

        /* Reveal is a progressive enhancement. Without JS the content shows by
           default (the opacity:0 start state only applies under .obt-armed).
           On the animated path we arm the section so the CSS keyframes run, then
           keep a safety timeout that force-reveals if anything stalls. */
        if (this.section && this.section.hasAttribute('data-obt-animate') && !reduce) {
          this.section.classList.add('obt-armed');
          this._safety = setTimeout(this._showAll, 1600);
        }

        if (this.dataset.parallax === 'off' || reduce) return;

        this.img = this.querySelector('.obt-reward-band__bg-img');
        if (!this.img) return;

        this.ticking = false;
        this.visible = false;
        this._onScroll = this._onScroll.bind(this);
        this._update = this._update.bind(this);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            if (this.visible) this._onScroll();
          }, { rootMargin: '120px 0px' });
          this.io.observe(this);
        } else {
          this.visible = true;
        }

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this.io) this.io.disconnect();
        if (this._safety) clearTimeout(this._safety);
      }

      _showAll() {
        if (!this.section) return;
        const items = this.section.querySelectorAll('.obt-reward-band__content > *');
        for (let i = 0; i < items.length; i++) items[i].classList.add('is-visible');
      }

      _onScroll() {
        if (!this.visible || this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(this._update);
      }

      _update() {
        const rect = this.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        /* progress: 0 when band bottom enters, 1 when band top exits the top */
        const total = rect.height + vh;
        const progress = Math.min(Math.max((vh - rect.top) / total, 0), 1);
        const shift = (progress - 0.5) * 2 * this.cap;
        this.img.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0) scale(1.08)';
        this.ticking = false;
      }
    }
    customElements.define('obt-reward-band', ObtRewardBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-scroll-progress"] && !Shopify.designMode) return;
  try {
    
  /* obt-scroll-progress — vanilla custom element.
     Reproduces the source initScrollbar(): a fixed page-edge rail whose fill
     height = scroll progress %. rAF-throttled, passive scroll + resize
     listeners, IntersectionObserver not needed (cost is trivial), guarded
     singleton (only one rail per page even if section dropped twice).
     Reduced-motion still updates position — it is an indicator, not decoration.
     Reads all config from data-* + inherited --obt-* custom properties. */
  if (!customElements.get('obt-scroll-progress')) {
    class ObtScrollProgress extends HTMLElement {
      connectedCallback() {
        // Theme-editor preview: render an inline static stub, do not go fixed.
        if (this.dataset.preview === 'on') {
          this._renderPreview();
          return;
        }

        // Singleton guard — only the first instance owns the global rail.
        if (document.querySelector('.obt-scroll-progress-rail:not(.obt-scroll-progress-rail--preview)')) {
          this._owns = false;
          return;
        }
        this._owns = true;

        const rail = document.createElement('div');
        rail.className = 'obt-scroll-progress-rail';
        rail.setAttribute('data-side', this.dataset.side || 'left');
        rail.setAttribute('data-position', this.dataset.position || 'edge');
        if (this.dataset.pulse) rail.setAttribute('data-pulse', this.dataset.pulse);
        if (this.dataset.obtAnimate) rail.setAttribute('data-obt-animate', this.dataset.obtAnimate);

        // Carry the per-instance custom properties onto the rail (it lives
        // outside this section's scoped subtree, so copy them explicitly).
        const cs = getComputedStyle(this);
        ['--obt-accent', '--obt-sand', '--obt-track-color', '--obt-thickness',
         '--obt-radius', '--obt-glow-opacity', '--obt-anim-duration', '--obt-anim-delay'
        ].forEach((prop) => {
          const v = cs.getPropertyValue(prop);
          if (v) rail.style.setProperty(prop, v.trim());
        });

        const fill = document.createElement('div');
        fill.className = 'obt-scroll-progress-rail__fill';
        rail.appendChild(fill);
        document.body.appendChild(rail);

        this._rail = rail;
        this._fill = fill;
        this._ticking = false;
        this._update = this._update.bind(this);
        this._onScroll = this._onScroll.bind(this);

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._update();
      }

      disconnectedCallback() {
        if (!this._owns) return;
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this._rail && this._rail.parentNode) {
          this._rail.parentNode.removeChild(this._rail);
        }
      }

      _onScroll() {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(this._update);
      }

      _update() {
        const st = window.scrollY || document.documentElement.scrollTop || 0;
        const h = document.documentElement.scrollHeight - window.innerHeight;
        const pct = h > 0 ? (st / h) * 100 : 0;
        this._fill.style.height = pct + '%';
        this._ticking = false;
      }

      _renderPreview() {
        const rail = document.createElement('div');
        rail.className = 'obt-scroll-progress-rail obt-scroll-progress-rail--preview';
        rail.setAttribute('data-side', this.dataset.side || 'left');
        rail.style.width = '6px';
        const fill = document.createElement('div');
        fill.className = 'obt-scroll-progress-rail__fill';
        rail.appendChild(fill);
        this.appendChild(rail);
      }
    }
    customElements.define('obt-scroll-progress', ObtScrollProgress);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('obt-steps-carousel')) {
    class ObtStepsCarousel extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.obt-steps');
        this.stage = this.querySelector('[data-stage]');
        this.track = this.querySelector('[data-track]');
        this.steps = this.track ? Array.from(this.track.querySelectorAll('[data-step]')) : [];
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.n = this.steps.length;
        if (!this.n || !this.stage) return;

        this.spread = parseFloat(this.dataset.spread) || 58;     // % of card width
        this.rotation = parseFloat(this.dataset.rotation) || 42; // degrees
        this.depth = parseFloat(this.dataset.depth) || 190;      // px push-back
        this.loop = this.n > 1;                                  // always loop (ring)
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.pos = Math.max(0, this.steps.findIndex((s) => s.classList.contains('is-active')));
        if (this.pos < 0) this.pos = 0;
        this.dragging = false;
        this.didDrag = false;

        // Tap / keyboard a card to roll it to the front.
        this.steps.forEach((s, i) => {
          s.addEventListener('click', () => { if (!this.didDrag) this.animateTo(i); });
          s.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); this.animateTo(i); }
          });
        });
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.animateTo(i)));
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

        // Arrow keys when the carousel has focus within.
        this.addEventListener('keydown', (e) => {
          if (e.target.closest('[data-step]')) return; // card handles its own keys
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
        });

        // Pointer drag / swipe (mouse + touch via Pointer Events).
        this._onMove = this.onMove.bind(this);
        this._onUp = this.onUp.bind(this);
        this.stage.addEventListener('pointerdown', this.onDown.bind(this));

        this._onResize = () => { this.measure(); this.render(); };
        window.addEventListener('resize', this._onResize, { passive: true });

        this.measure();
        this.render();
        this.updateChrome();
        this.reveal();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._raf);
        window.removeEventListener('resize', this._onResize);
        window.removeEventListener('pointermove', this._onMove);
        window.removeEventListener('pointerup', this._onUp);
        if (this.io) this.io.disconnect();
      }

      measure() {
        this.cardW = this.steps[0] ? this.steps[0].offsetWidth : 320;
        this.vwScale = Math.max(0.6, Math.min(1, window.innerWidth / 1024));
      }

      wrap(off) {
        if (!this.loop) return off;
        const n = this.n;
        off = ((off % n) + n) % n; // normalise into [0, n) — handles any number of laps
        if (off > n / 2) off -= n; // shift into (-n/2, n/2] so the nearest copy wins
        return off;
      }

      render() {
        const spacing = this.cardW * (this.spread / 100);
        this.steps.forEach((s, i) => {
          const off = this.wrap(i - this.pos);
          const a = Math.abs(off);
          const clamped = Math.max(-2, Math.min(2, off));
          const x = off * spacing;
          const z = -a * this.depth * (0.55 + 0.45 * this.vwScale);
          const ry = -clamped * this.rotation;
          const scale = Math.max(0.6, 1 - a * 0.13);
          const op = Math.max(0, 1 - Math.pow(a / 2.2, 1.6)); // bright front, faint back (seam hidden)
          s.style.transform =
            'translate(-50%, -50%) translateX(' + x + 'px) translateZ(' + z + 'px) rotateY(' + ry + 'deg) scale(' + scale + ')';
          s.style.opacity = op.toFixed(3);
          s.style.zIndex = String(1000 - Math.round(a * 100));
          s.style.pointerEvents = op < 0.12 ? 'none' : 'auto';
          const isActive = a < 0.5;
          s.classList.toggle('is-active', isActive);
          s.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        const idx = ((Math.round(this.pos) % this.n) + this.n) % this.n;
        this.dots.forEach((d, i) => {
          const on = i === idx;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      animateTo(i) {
        this.tweenTo(this.pos + this.wrap(i - this.pos));
      }

      step(dir) {
        let target = this.pos + dir;
        if (!this.loop) target = Math.max(0, Math.min(this.n - 1, target));
        this.tweenTo(target);
      }

      // Roll the ring to a target position by animating pos itself (continuous,
      // same model as dragging) so the seam card travels around the back rather
      // than flying across the front.
      tweenTo(target) {
        if (Math.abs(target - this.pos) < 0.0001) return;
        if (this.reduce) { this.pos = target; this.render(); this.updateChrome(); return; }
        cancelAnimationFrame(this._raf);
        const start = this.pos;
        const dist = target - start;
        const dur = Math.min(900, 360 + Math.abs(dist) * 220);
        const t0 = performance.now();
        const ease = (x) => 1 - Math.pow(1 - x, 3); // easeOutCubic
        this.track.classList.add('is-animating');
        const tick = (now) => {
          let p = (now - t0) / dur;
          if (p > 1) p = 1;
          this.pos = start + dist * ease(p);
          this.render();
          if (p < 1) {
            this._raf = requestAnimationFrame(tick);
          } else {
            this.pos = target;
            this.render();
            this.track.classList.remove('is-animating');
            this.updateChrome();
          }
        };
        this._raf = requestAnimationFrame(tick);
      }

      onDown(e) {
        if (e.button != null && e.button !== 0) return;
        this.dragging = true;
        this.didDrag = false;
        this.startX = e.clientX;
        this.startPos = this.pos;
        cancelAnimationFrame(this._raf);
        this.track.classList.add('is-animating');
        try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
        window.addEventListener('pointermove', this._onMove);
        window.addEventListener('pointerup', this._onUp);
        window.addEventListener('pointercancel', this._onUp);
      }

      onMove(e) {
        if (!this.dragging) return;
        const dx = e.clientX - this.startX;
        if (Math.abs(dx) > 4) this.didDrag = true;
        const spacing = this.cardW * (this.spread / 100);
        let p = this.startPos - dx / spacing;
        if (!this.loop) p = Math.max(-0.45, Math.min(this.n - 0.55, p));
        this.pos = p;
        this.render();
      }

      onUp() {
        if (!this.dragging) return;
        this.dragging = false;
        this.track.classList.remove('is-animating');
        window.removeEventListener('pointermove', this._onMove);
        window.removeEventListener('pointerup', this._onUp);
        window.removeEventListener('pointercancel', this._onUp);
        let target = Math.round(this.pos);
        if (!this.loop) target = Math.max(0, Math.min(this.n - 1, target));
        this.tweenTo(target); // smooth snap to the nearest card
      }

      updateChrome() {
        if (!this.prevBtn && !this.nextBtn) return;
        if (this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = false;
          if (this.nextBtn) this.nextBtn.disabled = false;
          return;
        }
        const idx = Math.round(this.pos);
        if (this.prevBtn) this.prevBtn.disabled = idx <= 0;
        if (this.nextBtn) this.nextBtn.disabled = idx >= this.n - 1;
      }

      reveal() {
        if (!this.section) return;
        if (this.reduce) { this.section.classList.add('is-revealed'); return; }
        this.io = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) { this.section.classList.add('is-revealed'); obs.disconnect(); }
          });
        }, { threshold: 0.12 });
        this.io.observe(this);
      }
    }
    customElements.define('obt-steps-carousel', ObtStepsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-system-flip"] && !Shopify.designMode) return;
  try {
    
  /* obt-flip — vanilla custom element.
     Click / Enter / Space toggles a .is-flipped class on this element, which
     CSS turns into a rotateY(180deg) on the inner panel. Mirrors the source's
     toggle0/rot0 behaviour. aria-expanded is kept in sync on the inner button.
     Reduced-motion users still get the flip (it's the core content reveal) but
     CSS removes the transition for them via the duration token staying short;
     no continuous animation runs. NO Liquid in here.

     FAIL-SAFE REVEAL: the cards' hidden start-states (opacity:0 / translate /
     clip) only apply when the section carries .obt-armed. This element arms the
     section on connect (only when motion is wanted) and then schedules a safety
     timeout that force-reveals everything by removing .obt-armed, so the section
     can never stay blank if the reveal animation stalls or is interrupted. */
  if (!customElements.get('obt-flip')) {
    class ObtFlip extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.obt-system-flip__btn');
        if (this.btn) {
          this._onClick = this._toggle.bind(this);
          this.btn.addEventListener('click', this._onClick);
        }
        this._arm();
      }

      disconnectedCallback() {
        if (this.btn) this.btn.removeEventListener('click', this._onClick);
        if (this._safety) clearTimeout(this._safety);
      }

      _arm() {
        var section = this.closest('.obt-system-flip');
        if (!section) return;
        // Already handled by a sibling card, or nothing to animate.
        if (section.dataset.obtArmedDone === '1') return;
        section.dataset.obtArmedDone = '1';

        var wantsMotion = section.hasAttribute('data-obt-animate');
        var reduced = false;
        try {
          reduced = window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        } catch (e) {}

        // Reduced-motion or no animation requested: leave content visible, never arm.
        if (!wantsMotion || reduced) return;

        section.classList.add('obt-armed');
        this._section = section;
        // Safety net: if the reveal animation never completes (editor, stalled
        // load, interrupted paint), force everything visible. Disarming removes
        // the hidden start-states so static content shows.
        this._safety = setTimeout(this._showAll.bind(this), 1600);
      }

      _showAll() {
        if (this._section) this._section.classList.remove('obt-armed');
      }

      _toggle() {
        const flipped = this.classList.toggle('is-flipped');
        if (this.btn) this.btn.setAttribute('aria-expanded', flipped ? 'true' : 'false');
      }
    }
    customElements.define('obt-flip', ObtFlip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials(root) {
      if (!root || root.dataset.obtTestiInit) return;
      root.dataset.obtTestiInit = '1';

      var car = root.querySelector('[data-obt-car]');
      var track = car ? car.querySelector('[data-obt-track]') : null;
      var modal = root.querySelector('[data-obt-modal]');
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var modalOpen = false;
      var lastFocused = null;

      function pause() { if (track) track.style.animationPlayState = 'paused'; }
      function play() { if (track && !modalOpen) track.style.animationPlayState = 'running'; }

      /* ---- popup (works with or without GSAP) ---- */
      function openModal(card) {
        if (!modal) return;
        lastFocused = card;
        var nameEl = modal.querySelector('[data-obt-modalname]');
        var roleEl = modal.querySelector('[data-obt-modalrole]');
        var quoteEl = modal.querySelector('[data-obt-modalquote]');
        var imgEl = modal.querySelector('[data-obt-modalimg]');
        var avEl = modal.querySelector('[data-obt-modalav]');
        var name = card.getAttribute('data-name') || '';

        if (nameEl) nameEl.textContent = name;
        if (roleEl) roleEl.textContent = card.getAttribute('data-role') || '';
        if (quoteEl) quoteEl.textContent = card.getAttribute('data-quote') || '';

        var src = card.getAttribute('data-img');
        if (imgEl) {
          if (src) {
            imgEl.src = src;
            /* a real alt, not an empty one — the portrait carries the person */
            imgEl.alt = card.getAttribute('data-imgalt') || name || '';
            imgEl.hidden = false;
          } else {
            imgEl.removeAttribute('src');
            imgEl.alt = '';
            imgEl.hidden = true;
          }
        }

        var avs = card.getAttribute('data-av');
        if (avEl) {
          if (avs) {
            var im = document.createElement('img');
            im.src = avs; im.alt = '';
            avEl.innerHTML = '';
            avEl.appendChild(im);
          } else {
            avEl.textContent = (name.trim().charAt(0) || '•');
          }
        }

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        modalOpen = true;
        pause();
        document.body.style.overflow = 'hidden';
        var closeBtn = modal.querySelector('[data-obt-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      }

      function closeModal() {
        if (!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modalOpen = false;
        document.body.style.overflow = '';
        play();
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }

      if (track) {
        track.addEventListener('click', function (e) {
          var c = e.target.closest('[data-obt-open]');
          if (c && track.contains(c)) openModal(c);
        });
      }

      if (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-obt-close]')) closeModal();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && modalOpen) closeModal();
        });
      }

      /* ---- carousel build. CSS owns the loop, so motion never depends on GSAP. ---- */
      function build() {
        if (!car || !track) return;
        if (reduce) {
          car.setAttribute('data-fallback', '');
          return;
        }
        var items = Array.prototype.slice.call(track.children).filter(function (n) {
          return n.matches && n.matches('[data-obt-open]');
        });
        if (!items.length) return;
        items.forEach(function (c) {
          var cl = c.cloneNode(true);
          cl.setAttribute('aria-hidden', 'true');
          cl.tabIndex = -1;
          track.appendChild(cl);
        });
        var firstClone = track.children[items.length];
        var dist = firstClone ? firstClone.offsetLeft - items[0].offsetLeft : track.scrollWidth / 2;
        if (!dist) { car.setAttribute('data-fallback', ''); return; }
        var pps = parseFloat(car.getAttribute('data-speed')) || 48;
        track.style.setProperty('--obt-loop-distance', dist + 'px');
        track.style.setProperty('--obt-loop-duration', Math.max(18, dist / pps) + 's');
        track.classList.add('is-looping');
        car.addEventListener('mouseenter', pause);
        car.addEventListener('mouseleave', play);
        car.addEventListener('focusin', pause);
        car.addEventListener('focusout', play);
        car.addEventListener('pointerdown', pause, { passive: true });
        car.addEventListener('pointerup', play, { passive: true });
        if ('ResizeObserver' in window) {
          new ResizeObserver(function () {
            var nextDist = firstClone ? firstClone.offsetLeft - items[0].offsetLeft : track.scrollWidth / 2;
            if (!nextDist) return;
            track.style.setProperty('--obt-loop-distance', nextDist + 'px');
            track.style.setProperty('--obt-loop-duration', Math.max(18, nextDist / pps) + 's');
          }).observe(car);
        }
      }

      if (document.readyState === 'complete') {
        build();
      } else {
        window.addEventListener('load', build, { once: true });
      }
    }

    function initAll() {
      document.querySelectorAll('.obt-testimonials').forEach(initTestimonials);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Theme editor: re-init when this section is added/reloaded */
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.obt-testimonials');
      if (root) initTestimonials(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-three-pillars"] && !Shopify.designMode) return;
  try {
    
  /* obt-pillars-grid — vanilla custom element.
     Only job: when animate-on-scroll is on, add the in-view class once the
     panel enters the viewport so the (otherwise paused) reveal animations
     run. Off-screen stays paused; reduced-motion users get the static layout.
     IntersectionObserver-gated, runs once, NO Liquid. */
  if (!customElements.get('obt-pillars-grid')) {
    class ObtPillarsGrid extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.obt-three-pillars');
        if (!section) return;

        // No reveal animation configured: nothing to gate, leave content visible.
        if (!section.hasAttribute('data-obt-animate')) return;

        // Reduced motion: show everything statically, never arm (no hidden state).
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          section.classList.add('obt-three-pillars--in-view');
          return;
        }

        // Animated path. Arm the hidden start state ONLY now that JS is running,
        // so a no-JS / interrupted load never leaves the cards invisible.
        section.classList.add('obt-armed');

        // Not scroll-gated: the CSS animation self-runs from the armed state.
        if (section.dataset.obtScroll !== 'true') return;

        // IntersectionObserver unavailable: reveal immediately.
        if (!('IntersectionObserver' in window)) {
          section.classList.add('obt-three-pillars--in-view');
          return;
        }

        this.io = new IntersectionObserver((entries, obs) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              section.classList.add('obt-three-pillars--in-view');
              obs.disconnect();
              break;
            }
          }
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
        this.io.observe(this);

        // Safety net: if the observer never fires (theme editor, odd loads),
        // force-reveal so the section can never stay blank.
        this.safetyTimer = setTimeout(() => {
          section.classList.add('obt-three-pillars--in-view');
          if (this.io) this.io.disconnect();
        }, 1600);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.safetyTimer) clearTimeout(this.safetyTimer);
      }
    }
    customElements.define('obt-pillars-grid', ObtPillarsGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-tournaments"] && !Shopify.designMode) return;
  try {
    
  /* obt-sheen — vanilla custom element wrapping the animated diagonal sheen.
     The sweep is a pure-CSS keyframe (obt-tournaments-sheen) driven entirely
     by the parent section's [data-obt-animate] flag + reduced-motion media
     query. This element manages an IntersectionObserver so the running
     animation is paused (animation-play-state) while the section is off-screen,
     saving compositor work. It also adds .is-in-view to the section so the
     per-tier entrance stagger fires once.

     FAIL-SAFE REVEAL: content is visible by default (no opacity:0 in CSS until
     the section is armed). Only the JS arms the section (.obt-armed) so that if
     JS never runs, is interrupted, or the IntersectionObserver never fires
     (theme editor / some storefront loads), the section can never be blank. On
     the animated path we arm, observe, and set a safety timeout that force-
     reveals everything (.obt-show-all) if the observer never fires. NO Liquid. */
  if (!customElements.get('obt-sheen')) {
    class ObtSheen extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.obt-tournaments');

        // Show-all (leave content visible) paths — never arm, never hide.
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) return;
        if (!this.section || this.section.getAttribute('data-obt-animate') === null) return;
        if (!('IntersectionObserver' in window)) {
          this._showAll();
          return;
        }

        // Animated path: arm the section so the hidden start-state CSS applies,
        // then reveal as the section enters the viewport.
        this.section.classList.add('obt-armed');

        this.io = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            const onScreen = entry.isIntersecting;
            this.style.animationPlayState = onScreen ? 'running' : 'paused';
            if (onScreen && this.section) {
              this.section.classList.add('is-in-view');
              this._clearSafety();
            }
          }
        }, { rootMargin: '0px 0px -10% 0px' });
        this.io.observe(this);

        // Safety: if the observer never fires (editor / odd load), force reveal.
        this._safety = setTimeout(() => this._showAll(), 1600);
      }

      _showAll() {
        if (this.section) this.section.classList.add('obt-show-all', 'is-in-view');
      }

      _clearSafety() {
        if (this._safety) {
          clearTimeout(this._safety);
          this._safety = null;
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        this._clearSafety();
      }
    }
    customElements.define('obt-sheen', ObtSheen);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-two-legs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setFlip(card, on) {
      card.classList.toggle('is-flipped', on);
      var front = card.querySelector('.obt-two-legs__face--front');
      var back = card.querySelector('.obt-two-legs__face--back');
      if (front) front.inert = on;
      if (back) back.inert = !on;
      var focusTo = on ? card.querySelector('[data-obt-flip-to="front"]') : card.querySelector('[data-obt-flip-to="back"]');
      if (focusTo) focusTo.focus();
    }
    function boot() {
      document.querySelectorAll('.obt-two-legs__card[data-obt-flip]').forEach(function (card) {
        if (card.dataset.obtReady) return;
        card.dataset.obtReady = '1';
        card.querySelectorAll('[data-obt-flip-to]').forEach(function (btn) {
          btn.addEventListener('click', function () { setFlip(card, btn.getAttribute('data-obt-flip-to') === 'back'); });
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && card.classList.contains('is-flipped')) setFlip(card, false);
        });
      });
    }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  /* GSAP: entrance (card rise + icon pop), continuous gentle float, hover lift.
     Reveal is driven by IntersectionObserver (NOT ScrollTrigger) because Horizon
     scrolls .page-wrapper, not window, so ScrollTrigger would never fire on desktop
     and leave the cards stuck hidden. Feature-detected + reduced-motion safe, with a
     failsafe that forces visibility no matter what. */
  (function () {
    function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function init() {
      var g = window.gsap;
      if (!g) return false;
      var cards = document.querySelectorAll('.obt-two-legs__card');
      if (!cards.length) return true;
      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      cards.forEach(function (card, i) {
        if (card.dataset.obtGsap) return;
        card.dataset.obtGsap = '1';
        var icon = card.querySelector('.obt-two-legs__img');

        if (icon && canHover) {
          card.addEventListener('mouseenter', function () { g.to(icon, { scale: 1.05, duration: 0.45, ease: 'power2.out', overwrite: 'auto' }); });
          card.addEventListener('mouseleave', function () { g.to(icon, { scale: 1, duration: 0.55, ease: 'power2.out', overwrite: 'auto' }); });
        }

        if (reduced()) return;

        g.set(card, { autoAlpha: 0, y: 38 });
        if (icon) g.set(icon, { autoAlpha: 0, y: 28, scale: 0.9 });

        var played = false;
        function play() {
          if (played) return;
          played = true;
          var tl = g.timeline();
          tl.to(card, { y: 0, autoAlpha: 1, duration: 0.7, ease: 'power3.out' });
          if (icon) {
            tl.to(icon, { y: 0, scale: 1, autoAlpha: 1, duration: 0.6, ease: 'power3.out' }, '-=0.45');
            tl.add(function () {
              g.to(icon, { y: '-=9', duration: 2.8 + i * 0.25, ease: 'sine.inOut', yoyo: true, repeat: -1 });
            });
          }
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) { play(); io.disconnect(); } });
          }, { threshold: 0.12 });
          io.observe(card);
          setTimeout(function () { play(); try { io.disconnect(); } catch (e) {} }, 2600);
        } else {
          play();
        }
      });
      return true;
    }
    function boot() {
      if (init()) return;
      var n = 0, t = setInterval(function () { n++; if (init() || n > 24) clearInterval(t); }, 150);
    }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-values"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('obt-values')) {
    class ObtValues extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.targets = Array.from(this.querySelectorAll('[data-io]'));

        if (this.reduce) {
          this.targets.forEach((el) => el.classList.add('is-in'));
          this.querySelectorAll('video[data-media]').forEach((v) => { try { v.autoplay = false; v.pause(); } catch (e) {} });
          return; // static posters, no ticking, no autoplay
        }

        if (this.targets.length) {
          this.io = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) { entry.target.classList.add('is-in'); obs.unobserve(entry.target); }
            });
          }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
          this.targets.forEach((el) => this.io.observe(el));
        }

        // Crystal emblem videos: play only while on screen, pause otherwise. Poster image stays behind.
        this.videos = Array.from(this.querySelectorAll('video[data-media]'));
        if (this.videos.length) {
          this.mediaIO = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const v = entry.target;
              if (entry.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
              else { v.pause(); }
            });
          }, { threshold: 0.25 });
          this.videos.forEach((v) => { v.muted = true; this.mediaIO.observe(v); });
        }

        // Reaction clock(s): accumulate time only while visible — "the moment slips away".
        this.clocks = Array.from(this.querySelectorAll('[data-timer]')).map((el) => ({ el, ms: 0, on: false }));
        if (this.clocks.length) {
          this.clockIO = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const c = this.clocks.find((x) => x.el === entry.target);
              if (c) c.on = entry.isIntersecting;
            });
          }, { threshold: 0 });
          this.clocks.forEach((c) => this.clockIO.observe(c.el));
          this.last = performance.now();
          this.tick = this.tick.bind(this);
          this.raf = requestAnimationFrame(this.tick);
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.mediaIO) this.mediaIO.disconnect();
        if (this.clockIO) this.clockIO.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      tick(now) {
        const dt = Math.min(120, now - this.last);
        this.last = now;
        if (!document.hidden) {
          for (const c of this.clocks) {
            if (!c.on) continue;
            c.ms += dt;
            c.el.textContent = this.fmt(c.ms);
          }
        }
        this.raf = requestAnimationFrame(this.tick);
      }

      fmt(ms) {
        const p = (n) => (n < 10 ? '0' + n : '' + n);
        const cs = Math.floor(ms / 10) % 100;
        const s = Math.floor(ms / 1000) % 60;
        const m = Math.min(99, Math.floor(ms / 60000));
        return p(m) + ':' + p(s) + '.' + p(cs);
      }
    }
    customElements.define('obt-values', ObtValues);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obt-wobble-cards"] && !Shopify.designMode) return;
  try {
    
  /* Shared, idempotent, window-guarded lazy GSAP loader. Loads GSAP core once
     across the whole page (the javascript tag is bundled once globally) and
     never blocks LCP — only invoked when a card is in view AND reduced-motion
     is no-preference. NO Liquid. */
  window.obtLoadGsap = window.obtLoadGsap || function(plugins){
    window.__obtGsapP = window.__obtGsapP || new Promise(function(res){
      var core = document.createElement("script");
      core.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js";
      core.onload = function(){ res(); };
      document.head.appendChild(core);
    });
    return window.__obtGsapP.then(function(){
      var jobs = (plugins||[]).map(function(p){
        if (window[p]) return Promise.resolve();
        window["__obtP_"+p] = window["__obtP_"+p] || new Promise(function(r){
          var s=document.createElement("script");
          s.src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/"+p+".min.js";
          s.onload=function(){ r(); }; document.head.appendChild(s);
        });
        return window["__obtP_"+p];
      });
      return Promise.all(jobs).then(function(){
        if (plugins) plugins.forEach(function(p){ if (window.gsap && window[p]) window.gsap.registerPlugin(window[p]); });
        return window.gsap;
      });
    });
  };

  /* obt-wobble — vanilla custom element, now GSAP-hybrid. Pointer position over
     the card drives a small 3D tilt (rotateX/rotateY + lift) while the inner
     content counter-moves and scales ~1.025 for parallax depth, plus a
     pointer-tracked light pool. The tilt/parallax math is unchanged — only the
     way it is applied changed: gsap.quickTo gives buttery, interruptible motion
     instead of hard per-frame transform writes. GSAP loads lazily ONCE, only
     when the card enters view AND reduced-motion is no-preference; otherwise the
     static CSS fallback stays untouched. Idle = zero work (listeners only fire
     on pointermove). Touch / reduced-motion = static. Config from data-tilt /
     data-parallax. NO Liquid. */
  if (!customElements.get('obt-wobble')) {
    class ObtWobble extends HTMLElement {
      connectedCallback() {
        const motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
        const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (this.dataset.motion === 'off' || !motionOk || !fine) return;

        this.tilt = parseFloat(this.dataset.tilt || '6');
        this.par = parseFloat(this.dataset.parallax || '8');
        this.inner = this.querySelector('.obt-wobble-cards__card-inner');
        this._nx = 0.5;
        this._ny = 0.5;
        this._ready = false;
        this._hovering = false;

        this._onMove = this._onMove.bind(this);
        this._onLeave = this._onLeave.bind(this);

        const root = this.closest('.obt-wobble-cards');
        if (root) root.setAttribute('data-obt-active', '');

        /* Lazy-load GSAP only when the card scrolls into view. Listeners are
           wired only after GSAP is ready, so the static state holds until then. */
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            entries.forEach((en) => {
              if (en.isIntersecting) {
                this._io.disconnect();
                this._io = null;
                this._initGsap();
              }
            });
          }, { rootMargin: '0px 0px 10% 0px' });
          this._io.observe(this);
        } else {
          this._initGsap();
        }
      }

      _initGsap() {
        if (this._ready) return;
        window.obtLoadGsap([]).then((gsap) => {
          if (!gsap || !this.isConnected) return;
          /* quickTo factories: interruptible, GPU-friendly setters that GSAP
             eases toward the latest target every tick. */
          this._toRX = gsap.quickTo(this, 'rotationX', { duration: 0.4, ease: 'power3.out' });
          this._toRY = gsap.quickTo(this, 'rotationY', { duration: 0.4, ease: 'power3.out' });
          this._toY = gsap.quickTo(this, 'y', { duration: 0.4, ease: 'power3.out' });
          if (this.inner) {
            this._toIX = gsap.quickTo(this.inner, 'x', { duration: 0.5, ease: 'power3.out' });
            this._toIY = gsap.quickTo(this.inner, 'y', { duration: 0.5, ease: 'power3.out' });
            this._toIS = gsap.quickTo(this.inner, 'scale', { duration: 0.5, ease: 'power3.out' });
          }
          this._gsap = gsap;
          this._ready = true;
          this.addEventListener('pointermove', this._onMove);
          this.addEventListener('pointerleave', this._onLeave);
        });
      }

      disconnectedCallback() {
        this.removeEventListener('pointermove', this._onMove);
        this.removeEventListener('pointerleave', this._onLeave);
        if (this._io) { this._io.disconnect(); this._io = null; }
      }

      _onMove(e) {
        if (!this._ready) return;
        const r = this.getBoundingClientRect();
        if (!r.width || !r.height) return;
        this._nx = (e.clientX - r.left) / r.width;   /* 0..1 */
        this._ny = (e.clientY - r.top) / r.height;   /* 0..1 */
        this.setAttribute('data-hover', '');
        this.style.setProperty('--obt-px', (this._nx * 100) + '%');
        this.style.setProperty('--obt-py', (this._ny * 100) + '%');

        const dx = this._nx - 0.5;  /* -0.5..0.5 */
        const dy = this._ny - 0.5;
        /* Identical tilt/parallax math — now fed to GSAP quickTo for easing. */
        this._toRY(dx * this.tilt * 2);
        this._toRX(-dy * this.tilt * 2);
        this._toY(-2);
        if (this.inner) {
          this._toIX(-dx * this.par);
          this._toIY(-dy * this.par);
          this._toIS(1.025);
        }
        this._hovering = true;
      }

      _onLeave() {
        if (!this._ready) return;
        this.removeAttribute('data-hover');
        /* Buttery reset back to rest via the same quickTo setters. */
        this._toRX(0);
        this._toRY(0);
        this._toY(0);
        if (this.inner) {
          this._toIX(0);
          this._toIY(0);
          this._toIS(1);
        }
        this._hovering = false;
      }
    }
    customElements.define('obt-wobble', ObtWobble);
  }

  /* Reveal trigger for the scroll-in animations (opt-in via data attr).
     FAIL-SAFE: content is visible by default (no .obt-armed = no opacity:0).
     We only arm a section when it actually has a reveal animation AND
     reduced-motion is no-preference; otherwise content is left untouched and
     fully visible. Once armed, every path guarantees the section ends up
     revealed: IntersectionObserver, a no-IO fallback, AND a hard safety
     timeout that force-reveals if the observer never fires (theme editor /
     interrupted load). */
  if (!window.__obtWcScroll) {
    window.__obtWcScroll = true;
    var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

    var reveal = function (s) { s.classList.add('obt-wobble-cards--in'); };

    var arm = function () {
      var all = document.querySelectorAll('.obt-wobble-cards[data-obt-animate]');
      if (!motionOk) {
        /* Reduced motion: never arm. Content stays visible, no animation. */
        return;
      }

      all.forEach(function (s) {
        var onScroll = s.hasAttribute('data-obt-on-scroll');
        /* Arm = enable the CSS hidden-state + animation for this section. */
        s.classList.add('obt-armed');

        if (!onScroll) {
          /* No scroll gating: CSS animation auto-plays from hidden to visible.
             Mark in immediately so animation-play-state is running. */
          reveal(s);
          return;
        }

        if (!('IntersectionObserver' in window)) {
          /* No IO support: reveal right away. */
          reveal(s);
          return;
        }

        /* Safety timeout: if the observer never fires (editor / odd load),
           force the section visible so it can never stay blank. */
        s._obtSafety = setTimeout(function () { reveal(s); }, 1600);
      });

      if (!('IntersectionObserver' in window) || !motionOk) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (en.target._obtSafety) { clearTimeout(en.target._obtSafety); en.target._obtSafety = null; }
            reveal(en.target);
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px' });

      all.forEach(function (s) {
        if (s.hasAttribute('data-obt-on-scroll')) io.observe(s);
      });
    };

    if (document.readyState !== 'loading') arm();
    else document.addEventListener('DOMContentLoaded', arm);
  }

  } catch(e) { console.error(e); }
})();
})();
